import React, { useEffect, useState } from 'react'
import { dataCreatedDbLocalI } from '../interfaces/useCreatePose.interface'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import NetInfo from '@react-native-community/netinfo'
import { DotsNavigation } from '../../navigation/stacks/NavigationStack'
import { fetchAuthSession } from 'aws-amplify/auth'
import { documentDirectory } from '../../../utils/fileSystemCompat'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { ScheduleModel, StoresListModel, CampaignModel, ActivitysModel, CampaignStepsModel, FormsAdvances } from '../models/ScheduleModel'
import { SCHEDULES_STORE_NAMES } from '../../../db/posSchedules'
import { schedulesServices } from '../../../../database/schedules.database'
import {
    request_get_schedules_advances,
    request_get_schedules_by_pos,
    request_get_schedules,
    request_get_all_store,
    request_get_schedule_period,
    request_checkin,
    request_checkout,
    request_get_schedule_forms,
    request_get_forms_additionals,
    request_add_pos,
    request_get_perfect_store,
    request_send_forms_view,
    request_get_forms_pending,
    FormsPending,
    request_save_form,
} from '../../../services/schedule.services'
import { UserServices } from '../../../../database/user.database'
import { getLocation } from '../../appBar/context/LocationContext'
import { getConection } from '../../appBar/context/HeaderContext'
import { CampaignStatus } from '../StatusTagsStores'
import { FORM_SCHEDULE_STATUS, STATUS_FORM_PENDING_SYNC, STORE_STATUS } from '../constants/constants.stores'
import { DatumHistory } from '../../../services/interfaces/schedule.interface/schedule.getformsadditionals.interface'
import { useLoaderSaveStores } from '../../../redux/zustand/loaderSaveStore'
import { StorageAdapter } from '../../../utils/AsyncStorage'
import { ASYNC_STORAGE_KEYS } from '../constants/constants.storage'
import { GetAllStoresResponse } from '../../../services/interfaces/schedule.interface'
import { useModerationPeriodStore } from '../../../redux/zustand/modarationPeriodStore'
import { useStoreStatusStore } from '../../../redux/zustand/storesStatusStore'
import { useFormView } from './useFormView'
import {
    deletePathFile,
    deleteZipFolder,
    downloadAndUnzip,
    downloadAndUnzipAllFiles,
    downloadContent,
    downloadContentPS,
    downloadZip,
    eventEmitter,
    findAssetsInDirectory,
    getAuthToken,
    getCountRegisterByUrl,
    getDataCountByUrl,
    getIdByURL,
    getVersionByURL,
    isValidDateString,
    isValidMongoId,
    readAndParseJSON,
    removeDuplicateLinks,
    setKeepAwake,
    unZip,
    validateConnectionNetwork,
} from '../../../utils/functions.utils'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { uploadImage } from '../../imageUploader/ImageStorage'
import { useStoreContext } from '../context/store.context'
import { useAlertsGeneralControllersStore, useAlertTextPS } from '../../../redux/zustand/alertsGeneralControllersStore'
import { useChangeColorAsset } from '../../../redux/zustand/changeColorAssetPSStore'
import { PROGRESS_STEPS, useProgressSchedule } from '../../../redux/zustand/progressScheduleStore'
import { useCreateStore } from './useCreateStore'
import { useCreatePos } from './useCreatePos'
import { TrackingServices } from '../../../../database/tracking.database'
import { TRACKINGS_TYPES } from '../../../utils/Constants'
import {
    addCampaing,
    getExistsInDB,
    saveFormsBatch,
    getAllCampaigns,
    addSchedulesBatch,
    addStoresBatch,
    addPosSchedulesBatch,
    addOrUpdateAdvanceSchedule,
    saveAllLinksAssetsBatch,
    addAllFormsPFBatch,
    addAllStoresPFRelationBatch,
    addAdvancesSchedules,
    cleanupLocalStores,
} from '../../../../db-sqlite/repositories/schedule.repository'
import { getRealDatabase } from '../../../../database-sqlite/DatabaseSingleton'
import { useFooterButtonsStore } from '../../../stores/useFooterButtonsStore'
import { useFooterApp } from '@/redux/zustand/footerAppStore'
import { useScheduleZip } from '@/redux/zustand/scheduleZipStore'

const PROCESSING_PENDINGS = 'PROCESSING_PENDINGS'
const STOP_PROCESS = ASYNC_STORAGE_KEYS.STOP_PROCESS_SCHEDULE

export const useSchedule = ({ withEffect = true } = {}) => {
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    const [stores, setStores] = useState<StoresListModel[]>([])
    const [campaign, setCampaign] = useState<CampaignModel[]>([])
    const [scheduleType, setType] = useState(0)
    const [reloadCounter, setReloadCounter] = useState(0)
    const { userLat, userLng, updateLocation } = getLocation()
    const [generator, setGenerator] = useState({ active: false, is_moderator: false, title: '' })
    const [loading, setLoading] = useState(true) // Estado para el indicador de carga
    const [loadingSchedule, setLoadingSchedule] = useState(false) // Estado para el indicador de carga
    const [allStores, setAllStores] = useState([])
    const { isConnected, hasInternet } = getConection()
    const [schedule, setSchedule] = useState<ScheduleModel[]>([])
    const [messageService, setMessageService] = useState('')
    const [errorService, setErrorService] = useState(false)
    const [historyForms, setHistoryForms] = useState<DatumHistory[]>([])
    const [refreshForms, setRefreshForms] = useState(false)
    const showMapButton = useFooterButtonsStore((state) => state.showMapButton)
    const showCreatePosButton = useFooterButtonsStore((state) => state.showCreatePosButton)
    const setShowMapButton = useFooterButtonsStore((state) => state.setShowMapButton)
    const setShowCreatePosButton = useFooterButtonsStore((state) => state.setShowCreatePosButton)
    const { sendFormsPending, sendForm } = useFormView({})
    const loaderSaveStores = useLoaderSaveStores()
    const moderationPeriodStore = useModerationPeriodStore()
    const [descriptionLoading, setDescriptionLoading] = useState('')
    const { languageFile } = getLanguage()
    const tagKeepAwake = 'DOWNLOAD_SCHEDULE'
    const [percentage, setPercentage] = useState(0)
    const { updateStoreStatus } = useStoreContext()
    const setShowAlertSnackbar = useAlertsGeneralControllersStore((store) => store.setShowAlertSnackbar)
    const { getAndSaveDataGeolocalization } = useCreateStore()
    const { sendStore, createStoreInDBLocal } = useCreatePos()
    const footer_app = useFooterApp((state) => state.footer_app)

    const pathFatherAssets = 'assets'

    const setTextsInitial = useAlertTextPS((store) => store.setTextsInitial)
    const setTextFinally = useAlertTextPS((store) => store.setTextFinally)
    const setTextError = useAlertTextPS((store) => store.setTextError)
    const setTextSecondary = useAlertTextPS((store) => store.setTextSecondary)
    const setCountPendingError = useAlertTextPS((store) => store.setCountPendingError)
    const setIsDownloadedCompletePS = useChangeColorAsset((state) => state.setIsDownloadedCompletePS)

    const setProgressSchedule = useProgressSchedule((store) => store.setProgressSchedule)
    const setIsVisibleProgressSchedule = useProgressSchedule((store) => store.setIsVisibleProgressSchedule)
    const setStoreStatus = useStoreStatusStore((state) => state.setStoreStatus)
    const setShowDownloadAssetPS = useChangeColorAsset((state) => state.setShowDownloadAssetPS)
    const setHasStoresZip = useScheduleZip((state) => state.setHasStoresZip)

    const MESSAGE_STATES = {
        LOADING: languageFile.loading,
        ERROR: languageFile.error_getting_data,
        NO_DATA: languageFile.no_information_to_display,
        DESCOMPRIMIENDO: languageFile.unzipping,
        DESCARGANDO: languageFile.saving,
        CARGANDO_TIENDAS: languageFile.loading_stores,
        OBTENIENDO_TIENDAS: languageFile.getting_stores,
        OBTENIENDO_FORMULARIOS_PS: 'Obteniendo formularios de perfect store...',
        OBTENIENDO_ASSETS_PS: 'Obteniendo assets de perfect store...',
    }

    const reloadCounterFn = () => {
        setReloadCounter((prevCounter) => prevCounter + 1)
    }

    useEffect(() => {
        if (withEffect) {
            fetchDataGetHistoryForms()
        }
    }, [refreshForms])

    const fetchDataGetHistoryForms = () => {
        try {
            getHistoryForms()
                .then((response) => {
                    if (response) {
                        setHistoryForms(response?.single?.data)
                        if (response.status == 0) {
                            console.log('consumo de mi base local')

                            schedulesServices
                                .getFormsAdditionals()
                                .then((response) => {
                                    setHistoryForms(response)
                                })
                                .catch((error) => {
                                    console.log('1 Error al obtener los formularios: ', error)
                                    setHistoryForms([])
                                })
                        } else {
                            setHistoryForms(response?.single?.data)
                            schedulesServices.saveFormsAdditionals(response.single.data)
                        }
                    }
                })
                .catch((error) => {
                    console.log('2 Error al obtener los formularios: ', error)
                    setHistoryForms([])
                })
        } catch (error) {
            console.error('🚀 ~ fetchDataGetHistoryForms ~ error:', error)
        }
    }

    const refreshForm = () => {
        setRefreshForms(!refreshForms)
    }

    const getHistoryForms = async () => {
        try {
            const netInfoState = await NetInfo.fetch()
            if (isConnected && hasInternet && netInfoState.isConnected && netInfoState.isInternetReachable) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ''

                const getLatestFormAdditional = await schedulesServices.getLatestFormAdditional()

                const response = await request_get_forms_additionals(authToken, getLatestFormAdditional ? getLatestFormAdditional?.date_finish : null)
                if (response && response.status && response.response.status == 1) {
                    return response.response
                } else {
                    return { status: 0, single: { data: [] } }
                }
            } else {
                return { status: 0, single: { data: [] } }
            }
        } catch (error) {
            console.error('63 -- Error al obtener los formularios: ', error)
            throw error
        }
    }

    const fetchData = async (count = 1) => {
        try {
            setIsVisibleProgressSchedule(true)
            const netInfoState = await NetInfo.fetch()
            console.log(
                netInfoState.isConnected,
                netInfoState.isInternetReachable,
                '========>>Estoy en el FETCH DE AGENDAAA',
                count,
                isConnected,
                hasInternet,
            )
            let session = null //await fetchAuthSession()
            let authToken = null //session.tokens?.accessToken?.toString() || ""
            let campaigns = []
            let data
            // setLoading(true) // Mostrar indicador de carga al iniciar la solicitud

            // if (netInfoState.isConnected && netInfoState.isInternetReachable) {

            //     console.log('😎1 INICIO START GENERAL LOADER: ', new Date())
            //     eventEmitter.emit('starGeneralLoaderCustom') //* ABRO

            // }

            setKeepAwake('active', tagKeepAwake)

            // update location
            try {
                if (isConnected && hasInternet && netInfoState.isConnected && netInfoState.isInternetReachable) {
                    //console.log('193- estoy en pendings')

                    // let pendings = await UserServices.get_pendings_conections()
                    // if (pendings && pendings.status == 0) {
                    //     console.log('193- estoy en el if de pendings', new Date())
                    //     await sendPendingConnection()
                    //     console.log('200- fin de pendings', new Date())
                    // }
                    try {
                        updateLocation()
                    } catch (error) {
                        console.error('🚀 ~ fetchData ~ error:location', error)
                    }
                }
            } catch (error) {
                console.error('149 --- updateLocation')
            }

            try {
                // console.log('🔵🔵🔵 [INICIO fetchData] Iniciando proceso de carga de agenda...')
                if (isConnected && hasInternet && netInfoState.isConnected && netInfoState.isInternetReachable) {
                    authToken = await getAuthToken()
                    // console.log('🔵 [fetchData] Token obtenido, hay conexión')
                } else {
                    console.log('🔴 [fetchData] Sin conexión a internet')
                }
                //priemro consume el local
                const version = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.SCHEDULES_VERSION)

                // console.log('🔵 [fetchData] Versión local obtenida:', version, 'tipo:', typeof version)
                // console.log('🔵 [fetchData] validateVersionSchedule(version) =', validateVersionSchedule(version))

                // set map button
                try {
                    // console.log('🚀🚀🚀🚀🚀🚀🚀🚀 ~ fetchData ~ setMapButton')
                    setMapButton()
                } catch (error) {
                    // console.log('🚀 ~ fetchData ~ error:setMapButton', error)
                }
                let forceReDownload = false
                if (validateVersionSchedule(version)) {
                    // console.log('========>>TENGO VERSION LOCAL DE AGENDAAA', version)
                    campaigns = await getAllCampaigns()

                    if (campaigns.length > 0) {
                        const { date_moderation_init, date_moderation_finish, moderation = false } = campaigns[0]

                        if (date_moderation_init && date_moderation_finish) {
                            moderationPeriodStore.setModeration(
                                new Date(date_moderation_init).toISOString(),
                                new Date(date_moderation_finish).toISOString(),
                                moderation,
                            )
                        } else {
                            // console.error('Las fechas de moderación no están definidas.')
                        }

                        const todaySchedule = getDaySchedule(campaigns[0]['schedules'])
                        // console.log('🚀 ~ fetchData ~ todaySchedule:', todaySchedule)

                        const totalStores = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_STORES)
                        // console.log('totalStores => ', totalStores)

                        const totalSchedulePos = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_SCHEDULES_POS)
                        const totalScheduleForms = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_SCHEDULES_FORMS)
                        const totalFormPerfectStore = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_FORMS_PERFECT_STORE)
                        const totalRelationPerfectStore = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_RELATION_PERFECT_STORE)

                        const totalSchedulePosIsCorrect = await schedulesServices.hasSchedulePosInDatabase(totalSchedulePos)
                        const totalStoresIsCorrect = await schedulesServices.hasStoresInDatabase(totalStores)
                        const totalFormsIsCorrect = await schedulesServices.CheckSavedRecords(SCHEDULES_STORE_NAMES.FORMS, totalScheduleForms)
                        const totalFormsPerfectStoreIsCorrect = await schedulesServices.hasFormsPerfectStoreInDatabase(totalFormPerfectStore)
                        const totalRelationPerfectStoreIsCorrect =
                            await schedulesServices.hasRelationPerfectStoreInDatabase(totalRelationPerfectStore)

                        const dataDownloaded = {
                            cantStoreIsCorrect: totalStoresIsCorrect,
                            cantSchedulePosIsCorrect: totalSchedulePosIsCorrect && totalFormsIsCorrect,
                            cantFormsPerfectStoreIsCorrect: totalFormsPerfectStoreIsCorrect,
                            cantRelationPerfectStoreIsCorrect: totalRelationPerfectStoreIsCorrect,
                        }
                        console.log('🔍 [DEBUG] forceReDownload BEFORE:', forceReDownload)
                        forceReDownload = Object.values(dataDownloaded).some((v) => v === false)
                        console.log('🔍 [DEBUG] forceReDownload AFTER:', forceReDownload)
                        console.log('📊 [DEBUG] Datos descargados:', JSON.stringify(dataDownloaded, null, 2))
                        console.log('🔵 [DEBUG] ¿Necesita re-descarga?:', forceReDownload, '- Si es true, descargará datos faltantes')
                        
                        // ✅ Siempre mostrar los datos locales primero
                        const paramsSetData = {
                            data: campaigns,
                            version: todaySchedule ? todaySchedule?.data_version : null,
                            downloaded: dataDownloaded,
                        }

                        await setData(paramsSetData)

                        console.log('========>>TERMINO EL FETCH DE AGENDAAA LOCAL')
                        setLoading(false)
                        eventEmitter.emit('endGeneralLoaderCustom')
                    } else {
                        if (isConnected && hasInternet && netInfoState.isConnected && netInfoState.isInternetReachable) {
                            await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.SCHEDULES_VERSION, null)
                        }
                    }
                } else {
                    console.log('========>>NO TENGO VERSION LOCAL DE AGENDAAA')
                }

                const version_schedules = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.SCHEDULES_VERSION)

                console.log('� [fetchData] Versión para enviar al servidor (version_schedules):', version_schedules)
                console.log('🔵 [fetchData] Tipo de version_schedules:', typeof version_schedules)

                if (isConnected && hasInternet && netInfoState.isConnected && netInfoState.isInternetReachable) {
                    setKeepAwake('active', tagKeepAwake)
                    setLoadingSchedule(true)
                    console.log('🔵🔵🔵 [CRITICAL] Llamando a request_get_schedules con version:', version_schedules)
                    // data = await retryRequest(request_get_schedules, [{ authToken, version: version_schedules }], 3)
                    const response_service = await request_get_schedules({ authToken, version: version_schedules, retries: version ? 0 : 3 })

                    data = response_service.response
                    console.log('🔵🔵🔵 [CRITICAL] Response de get_schedules - status:', data?.status)
                    console.log('========>>DATA DE AGENDAAA', data)
                    // Periodo generator
                    if (data && data.single && data.single.generator && data.single.generator.active) {
                        let data2 = await request_get_schedule_period({ authToken })
                        let title = 'Armar agenda'

                        if (data2 && data2.period && data2.period) {
                            const status = data2.period.status
                            console.log('status', status)
                            if (status == 0 || status == 2 || status == 8) {
                                console.log('Entro')
                                title = 'Armar agenda del mes'
                            } else {
                                title = 'Armar agenda de la semana'
                            }
                        }
                        let generator = data.single.generator
                        generator.title = title
                        setGenerator(generator)
                    }
                    if (data && data.status == 1) {
                        // set map button

                        setProgressSchedule(PROGRESS_STEPS.STEP_1.start)
                        eventEmitter.emit('starGeneralLoaderCustom', '') //* ABRO
                        campaigns = data?.single?.campaings

                        if (campaigns.length > 0) {
                            const { date_moderation_init, date_moderation_finish, moderation = false } = campaigns[0]

                            if (date_moderation_init && date_moderation_finish) {
                                moderationPeriodStore.setModeration(
                                    new Date(date_moderation_init).toISOString(),
                                    new Date(date_moderation_finish).toISOString(),
                                    moderation,
                                )
                            } else {
                                console.error('Las fechas de moderación no están definidas.')
                            }
                        } else {
                            console.error('La campaña no está definida.')
                        }

                        console.log('📦 [fetchData] Guardando campaña:', data?.single?.campaings[0]._id)
                        await addCampaing(data?.single?.campaings[0])
                        console.log('✅ [fetchData] Campaña guardada exitosamente')

                        let saveScheduleForms = false
                        let saveFormsAttempt = 0
                        while (!saveScheduleForms) {
                            saveFormsAttempt++
                            try {
                                console.log(`📦 [fetchData] Guardando formularios (intento ${saveFormsAttempt})...`)
                                let save_forms = await saveForms(authToken)
                                saveScheduleForms = save_forms ? save_forms.complete : false
                                if (saveScheduleForms) {
                                    console.log(`✅ [fetchData] Formularios guardados: ${save_forms.forms.length}`)
                                    if (save_forms && save_forms.forms.length > 0) {
                                        const medias = getMediasToDownload(save_forms.forms)
                                        const mediasToDownload = removeDuplicateLinks(medias)

                                        downloadContent(pathFatherAssets, mediasToDownload)
                                    }
                                } else {
                                    console.warn(`⚠️ [fetchData] Guardado incompleto en intento ${saveFormsAttempt}. Reintentando...`)
                                }
                            } catch (error) {
                                console.error(`❌ [fetchData] Error al guardar formularios (intento ${saveFormsAttempt}):`, {
                                    error: error?.message || error,
                                    name: error?.name,
                                    stack: error?.stack?.split('\n').slice(0, 3),
                                })
                                console.warn(`🔄 [fetchData] Reintentando debido al error...`)
                            }

                            // retraso entre intentos para evitar que consuma demasiados recursos
                            await new Promise((resolve) => setTimeout(resolve, 1000)) // 1 segundo
                        }

                        // add info create Store
                        if (data?.single?.create_pos && Object.keys(data.single.create_pos).length > 0) {
                            await schedulesServices.addInfoCreateStores(data?.single?.create_pos)
                        }
                        setMessageService('Cargando tiendas...\nEste proceso podría demorar unos minutos')
                        let title = 'Cargando tiendas'
                        let subtitle = 'Este proceso podría demorar unos minutos'
                        const get_item_stop = await AsyncStorage.getItem(STOP_PROCESS)
                        if (get_item_stop != 'true') {
                            console.log('2 INICIO START GENERAL LOADER: ', new Date())
                            eventEmitter.emit('starGeneralLoaderCustom', title, subtitle) //* ABRO
                        }
                        const savedSchedules = await addSchedulesBatch(data?.single?.campaings[0]['schedules'], data?.single?.campaings[0]['_id'])
                        console.log(`✅ Schedules guardados: ${savedSchedules}`)

                        let allStoresDone = false
                        let schedulesPosDone = false

                        console.log('📦 [fetchData] Guardando tiendas...')
                        const todaySchedule = getDaySchedule(data.single.campaings[0]['schedules'])
                        let initialData = await saveAllStores(authToken, 'zip', todaySchedule?.data_version)
                        allStoresDone = initialData ? initialData.complete : false
                        console.log(`✅ [fetchData] Tiendas guardadas - Complete: ${allStoresDone}`)

                        console.log('📦 [fetchData] Guardando schedule pos...')
                        let schedulePos = await saveSchedulePos(authToken, 'zip')
                        schedulesPosDone = schedulePos ? schedulePos.complete : false
                        console.log(`✅ [fetchData] Schedule pos guardados - Complete: ${schedulesPosDone}`)

                        console.log('📦 [fetchData] Guardando schedule advances...')
                        await saveScheduleAdvances(authToken)
                        console.log('✅ [fetchData] Schedule advances guardados')
                        // let save_forms = await saveForms(authToken)
                        // saveScheduleForms = save_forms ? save_forms.complete : false

                        // Actualizar la versión global
                        // ✅ Validación: verificar que campaings existe y tiene elementos
                        if (!data?.single?.campaings?.[0]?.schedules) {
                            console.error('❌ [fetchData] Error: data.single.campaings[0] no tiene schedules')
                            throw new Error('Estructura de datos incompleta: falta campaings[0].schedules')
                        }
                        console.log('========>>TERMINO EL FETCH DE AGENDAAA BACK', todaySchedule?.data_version)

                        //Pasar allsStores y schedulePos (Bools) para validar version

                        // const version = todaySchedule?.data_version
                        const dataDownloaded = {
                            cantStoreIsCorrect: allStoresDone,
                            cantSchedulePosIsCorrect: schedulesPosDone && saveScheduleForms,
                            cantFormsPerfectStoreIsCorrect: true, // en el primer fetch paso a true, para que en el segundo envie el valor correcto
                            cantRelationPerfectStoreIsCorrect: true, // en el primer fetch paso a true, para que en el segundo envie el valor correcto
                        }

                        const paramsSetData = {
                            data: data.single.campaings,
                            version: todaySchedule?.data_version,
                            downloaded: dataDownloaded,
                        }

                        // console.log('1🚀 ~ fetchData ~ paramsSetData:', paramsSetData)

                        await setData(paramsSetData)

                        // setData(data.single.campaings, todaySchedule?.data_version, allStoresDone, schedulesPosDone && saveScheduleForms)
                    } else {
                        // status: 0 significa que la versión es la misma, no hay cambios nuevos del servidor
                        console.log('========>>NO HAY NUEVA INFO DE AGENDAA (status 0)')
                        
                        // Solo forzar ReDescarga si realmente faltan datos (forceReDownload por datos incompletos)
                        if (data && data.status == 0 && forceReDownload) {
                            console.log('🔄 [ReDescarga] Forzando ReDescarga - Completando datos faltantes')
                            
                            // ✅ IMPORTANTE: Cuando data.status == 0, no hay nueva info del servidor,
                            // así que debemos usar los datos de la DB local, NO de data.single.campaings
                            const localCampaigns = await getAllCampaigns()
                            
                            if (!localCampaigns || localCampaigns.length === 0) {
                                console.error('❌ [ReDescarga] No hay campañas locales para re-descargar')
                                // No podemos continuar sin una campaña de referencia
                                return
                            }

                            // ✅ Recalcular dataDownloaded en este punto para tener el estado actual
                            const totalSchedulePos = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_SCHEDULES_POS)
                            const totalStores = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_STORES)
                            const totalScheduleForms = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_SCHEDULES_FORMS)
                            const totalFormPerfectStore = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_FORMS_PERFECT_STORE)
                            const totalRelationPerfectStore = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_RELATION_PERFECT_STORE)

                            const totalSchedulePosIsCorrect = await schedulesServices.hasSchedulePosInDatabase(totalSchedulePos)
                            const totalStoresIsCorrect = await schedulesServices.hasStoresInDatabase(totalStores)
                            const totalFormsIsCorrect = await schedulesServices.CheckSavedRecords(SCHEDULES_STORE_NAMES.FORMS, totalScheduleForms)
                            const totalFormsPerfectStoreIsCorrect = await schedulesServices.hasFormsPerfectStoreInDatabase(totalFormPerfectStore)
                            const totalRelationPerfectStoreIsCorrect = await schedulesServices.hasRelationPerfectStoreInDatabase(totalRelationPerfectStore)

                            const redownloadData = {
                                cantStoreIsCorrect: totalStoresIsCorrect,
                                cantSchedulePosIsCorrect: totalSchedulePosIsCorrect && totalFormsIsCorrect,
                                cantFormsPerfectStoreIsCorrect: totalFormsPerfectStoreIsCorrect,
                                cantRelationPerfectStoreIsCorrect: totalRelationPerfectStoreIsCorrect,
                            }
                            console.log('📊 [ReDescarga] Estado de datos:', JSON.stringify(redownloadData, null, 2))

                            let allStoresDone = redownloadData.cantStoreIsCorrect // Usar el valor de la validación actual
                            let schedulesPosDone = redownloadData.cantSchedulePosIsCorrect // Usar el valor de la validación actual
                            
                            // Obtener la versión del schedule para usarla en las tiendas
                            const todaySchedule = getDaySchedule(localCampaigns[0]['schedules'])
                            
                            // Solo descargar lo que falta
                            if (!redownloadData.cantStoreIsCorrect) {
                                console.log('📦 [ReDescarga] Guardando tiendas...')
                                let initialData = await saveAllStores(authToken, 'zip', todaySchedule?.data_version)
                                allStoresDone = initialData ? initialData.complete : false
                                console.log(`✅ [ReDescarga] Tiendas guardadas - Complete: ${allStoresDone}`)
                            } else {
                                console.log('⏭️ [ReDescarga] Tiendas ya están completas, omitiendo descarga')
                            }

                            if (!redownloadData.cantSchedulePosIsCorrect) {
                                console.log('📦 [ReDescarga] Guardando schedule pos...')
                                let schedulePos = await saveSchedulePos(authToken, 'zip')
                                schedulesPosDone = schedulePos ? schedulePos.complete : false
                                console.log(`✅ [ReDescarga] Schedule pos guardados - Complete: ${schedulesPosDone}`)
                            } else {
                                console.log('⏭️ [ReDescarga] Schedule pos ya están completos, omitiendo descarga')
                            }

                            console.log('📦 [ReDescarga] Guardando schedule advances...')
                            await saveScheduleAdvances(authToken)
                            console.log('✅ [ReDescarga] Schedule advances guardados')

                            // Actualizar la versión global usando los datos de la DB local
                            console.log('========>>TERMINO EL FETCH DE AGENDAAA BACK (ReDescarga)', todaySchedule?.data_version)

                            const finalDataDownloaded = {
                                cantStoreIsCorrect: allStoresDone,
                                cantSchedulePosIsCorrect: schedulesPosDone && true,
                                cantFormsPerfectStoreIsCorrect: true,
                                cantRelationPerfectStoreIsCorrect: true,
                            }

                            const paramsSetData = {
                                data: localCampaigns,  // ✅ Usar datos locales, NO data.single.campaings
                                version: todaySchedule?.data_version,
                                downloaded: finalDataDownloaded,
                            }
                            
                            console.log('📊 [ReDescarga] Llamando a setData con:', {
                                version: todaySchedule?.data_version,
                                dataDownloaded: finalDataDownloaded,
                            })
                            
                            await setData(paramsSetData)
                            
                            console.log('✅ [ReDescarga] setData completado')
                        } else if (data && data.status == 0 && !forceReDownload) {
                            // ✅ CASO: Todos los datos están completos Y el servidor dice que la versión es correcta
                            // Necesitamos asegurarnos de actualizar la versión en la DB local
                            console.log('✅ [fetchData] Versión actual correcta, todos los datos completos')
                            
                            const localCampaigns = await getAllCampaigns()
                            if (localCampaigns && localCampaigns.length > 0) {
                                const todaySchedule = getDaySchedule(localCampaigns[0]['schedules'])
                                
                                // Obtener el estado actual de los datos
                                const totalSchedulePos = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_SCHEDULES_POS)
                                const totalStores = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_STORES)
                                const totalScheduleForms = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_SCHEDULES_FORMS)
                                const totalFormPerfectStore = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_FORMS_PERFECT_STORE)
                                const totalRelationPerfectStore = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_RELATION_PERFECT_STORE)

                                const totalSchedulePosIsCorrect = await schedulesServices.hasSchedulePosInDatabase(totalSchedulePos)
                                const totalStoresIsCorrect = await schedulesServices.hasStoresInDatabase(totalStores)
                                const totalFormsIsCorrect = await schedulesServices.CheckSavedRecords(SCHEDULES_STORE_NAMES.FORMS, totalScheduleForms)
                                const totalFormsPerfectStoreIsCorrect = await schedulesServices.hasFormsPerfectStoreInDatabase(totalFormPerfectStore)
                                const totalRelationPerfectStoreIsCorrect = await schedulesServices.hasRelationPerfectStoreInDatabase(totalRelationPerfectStore)

                                const currentDataDownloaded = {
                                    cantStoreIsCorrect: totalStoresIsCorrect,
                                    cantSchedulePosIsCorrect: totalSchedulePosIsCorrect && totalFormsIsCorrect,
                                    cantFormsPerfectStoreIsCorrect: totalFormsPerfectStoreIsCorrect,
                                    cantRelationPerfectStoreIsCorrect: totalRelationPerfectStoreIsCorrect,
                                }
                                
                                const paramsSetData = {
                                    data: localCampaigns,
                                    version: todaySchedule?.data_version,
                                    downloaded: currentDataDownloaded,
                                }
                                
                                console.log('📊 [fetchData] Actualizando versión con datos completos:', {
                                    version: todaySchedule?.data_version,
                                    dataDownloaded: currentDataDownloaded,
                                })
                                
                                await setData(paramsSetData)
                            }
                        }
                        
                        // Continuar con actualización de advances
                        if (isConnected && hasInternet && netInfoState.isConnected && netInfoState.isInternetReachable) {
                            try {
                                await getAndUpdateScheduleAdvance(authToken)
                            } catch (error) {
                                console.error('🚀 ~ fetchData ~ error:', error)
                            }
                        } else {
                            console.log('log 6')
                        }
                    }
                }
                if (campaigns.length == 0) {
                    if (count != null && count < 3) {
                        await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.SCHEDULES_VERSION, null)
                        fetchData(count + 1)
                    }
                }

                //* ps
                if (isConnected && hasInternet && netInfoState.isConnected && netInfoState.isInternetReachable) {
                    console.log('📦 [fetchData] Iniciando saveAllFormsPF...')
                    await saveAllFormsPF(authToken)
                    console.log('✅ [fetchData] saveAllFormsPF completado')
                } else {
                    console.log('⚠️ [fetchData] Sin conexión, omitiendo Perfect Store')
                }
            } catch (error) {
                console.error('❌ [fetchData] Error en bloque try principal:', {
                    error: error?.message || error,
                    name: error?.name,
                    stack: error?.stack?.split('\n').slice(0, 3),
                })
                setLoading(false)
                eventEmitter.emit('endGeneralLoaderCustom')
                throw error
            } finally {
                console.log('🔚 [fetchData] Finalizando fetchData (finally interno)')
                setLoadingSchedule(false)
                setLoading(false) // Ocultar indicador de carga al finalizar la solicitud principal
                eventEmitter.emit('endGeneralLoaderCustom')
                setKeepAwake('desactive', tagKeepAwake)
            }
        } catch (error) {
            console.error('❌ [fetchData] Error en bloque try/catch externo:', {
                error: error?.message || error,
                name: error?.name,
                cause: error?.cause,
            })
            setLoading(false)
            setLoadingSchedule(false)
            eventEmitter.emit('endGeneralLoaderCustom')
            setKeepAwake('desactive', tagKeepAwake)
            throw error
        } finally {
            setIsVisibleProgressSchedule(false)
            await checkFormsPendings()
        }
    }

    const validateVersionSchedule = (version: any) => {
        if (version === null || version === undefined || version === '') return false
        return true
    }

    const checkFormsPendings = async () => {
        try {
            const hasConnection = await validateConnectionNetwork()

            if (!hasConnection) {
                console.log('checkFormsPendings => No hay conexión a internet')
                return
            }

            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString() || ''

            const response = await request_get_forms_pending(authToken)

            if (response && response.single && response.status && response.status === 1) {
                const formsPending = response.single.formsPending || []
                // console.log('checkFormsPendings => formsPending: ', formsPending)

                if (!formsPending || formsPending.length === 0) {
                    console.log('checkFormsPendings => No hay formularios pendientes')
                    return
                }

                const formsToSend = await findRegisterToSend(formsPending)

                // console.log('checkFormsPendings => formsToSend: ', formsToSend)

                if (formsToSend && formsToSend.length > 0) {
                    for (const form of formsToSend) {
                        await sendFormsSync(form)
                    }
                }
            }
        } catch (error) {
            console.error('checkFormsPendings => error: ', error)
        }
    }

    const sendFormsSync = async (form) => {
        try {
            const obj_json_raw = {
                answers: form.answers,
                date_finish: isValidDateString(form.date_finish) ? form.date_finish : form.date_init,
                date_init: form.date_init,
                id_activity: form.form_id,
                status: 0,
                progress: form.progress_questions_yes_na,
                score: form.scoreObtained,
                heladera: form.heladera,
                create_refrigerator: form.create_refrigerator,
                input_type: form.type_form ? form.type_form['type'] : null,
                refrigerator_id: '',
                store_id: form.store_id,
                // status_form: form.status,
                // schedule_id: form.schedule_id,
                // checkin_id: form.checkin_id || null,
            }

            // ✅ Si es formulario hijo (tiene form_id_father), el form_id ES el refrigerator_id
            if (form.form_id_father && form.form_id_father !== '' && form.form_id_father != '0') {
                console.log('📋 Formulario hijo en sync:', { form_id: form.form_id, form_id_father: form.form_id_father, heladera: form.heladera })
                obj_json_raw.id_activity = form.form_id_father // Enviar ID del padre
                obj_json_raw.refrigerator_id = form.form_id // El form_id del hijo ES el refrigerator_id
            }

            const json_raw = [obj_json_raw]

            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString() || ''
            let dif_utc = -new Date().getTimezoneOffset() / 60

            const data = {
                authToken: authToken,
                body: {
                    form: JSON.stringify(json_raw),
                    process_now: true,
                    date: new Date().toISOString(),
                    schedule_id: form.schedule_id,
                    checkin_id: form.checkin_id || null,
                    dif_utc: dif_utc.toString(),
                },
            }

            // console.log('sendFormsSync => data: ', data)
            const res = await request_save_form(data)
            // console.log('sendFormsSync => res: ', res)
        } catch (error) {
            console.error('sendFormNow Error ===>: ', error)
        }
    }

    const findRegisterToSend = async (formsPending: FormsPending[]) => {
        const registerToSend = []

        for (const register of formsPending) {
            const scheduleId = register.schedule_id || null
            const checkinId = register.checkin_id || null
            const forms = register.forms || []

            if (scheduleId == null || forms.length === 0) {
                // console.log('findRegisterToSend => Registro inválido:', register)
                continue
            }

            const formsToFQA = await schedulesServices.getFormsPendingSyncToSend(scheduleId, checkinId, forms)

            registerToSend.push(formsToFQA)
            // console.log('findRegisterToSend => formsToFQA:', formsToFQA)
        }

        return registerToSend.flat()
    }

    const getAndUpdateScheduleAdvance = async (authToken: string) => {
        try {
            const reg = await schedulesServices.getLatestAdvanceSchedule()

            if (reg && reg.date_modified) {
                // console.log('estoy buscando avancess', reg)
                await updateScheduleAdvances(authToken, reg.date_modified) // Timeout de 10 segundos
                    .catch((error) => {
                        console.error('Error o timeout en updateScheduleAdvances:', error)
                    })
            }

            const regPending = await schedulesServices.getLatestAdvancePendingsSchedule()
            // console.log('regPending => ', regPending)
            if (regPending && regPending.date_modified) {
                // console.log('2estoy buscando avancess', regPending)
                await updateScheduleAdvances(authToken, regPending.date_modified) // Timeout de 10 segundos
                    .catch((error) => {
                        console.error('2Error o timeout en updateScheduleAdvances:', error)
                    })
            }

            // await schedulesServices.getLatestAdvanceSchedule().then(async (reg) => {
            //     if (reg && reg.date_modified) {
            //         console.log('estoy buscando avancess', reg.date_modified)
            //         await updateScheduleAdvances(authToken, reg.date_modified) // Timeout de 10 segundos
            //             .catch((error) => {
            //                 console.error('Error o timeout en updateScheduleAdvances:', error)
            //             })
            //     }
            // })
        } catch (error) {
            throw new Error('getAndUpdateScheduleAdvance => error: ', error)
        }
    }

    const getMediasToDownload = (array: any[]): string[] => {
        let mediasToDownload: string[] = []
        try {
            array.forEach((form: any) => {
                if (form && form.icon && includeHttp(form.icon)) {
                    mediasToDownload.push(form.icon)
                }
                if (form && form.icon_check && includeHttp(form.icon_check)) {
                    mediasToDownload.push(form.icon_check)
                }
                if (form && form.contents && form.contents.length > 0) {
                    form.contents.forEach((content: any) => {
                        if (content && content.media && includeHttp(content.media)) {
                            mediasToDownload.push(content.media)
                        }
                        if (content && content.tag && content.tag.media && includeHttp(content.tag.media)) {
                            mediasToDownload.push(content.tag.media)
                        }
                    })
                }
            })
            return mediasToDownload
        } catch (error) {
        } finally {
            return mediasToDownload
        }
    }

    const includeHttp = (media: string): boolean => {
        let hasInclude = false
        if (media.includes('http')) {
            return true
        }
        return hasInclude
    }

    const getDaySchedule = (schedules) => {
        let todaySchedule = null
        let fecha_hoy = new Date()
        fecha_hoy.setMinutes(fecha_hoy.getMinutes() - fecha_hoy.getTimezoneOffset())
        const today = new Date(fecha_hoy)

        todaySchedule = schedules.find((schedule) => {
            const scheduleDateInit = new Date(schedule.date_init)
            const scheduleDateFinish = new Date(schedule.date_finish)

            return scheduleDateInit <= today && scheduleDateFinish >= today
        })

        return todaySchedule
    }
    interface ISetData {
        data: CampaignModel[]
        version: string | null
        downloaded: {
            cantStoreIsCorrect: Boolean
            cantSchedulePosIsCorrect: Boolean
            cantFormsPerfectStoreIsCorrect: Boolean
            cantRelationPerfectStoreIsCorrect: Boolean
        }
    }
    // const setData = async (data: CampaignModel[], version = null, cantStoreIsCorrect: Boolean, cantSchedulePosIsCorrect?: Boolean, cantPerfectStoreIsCorrect?: Boolean) => {
    const setData = async ({ data, version = null, downloaded }: ISetData) => {
        const { cantStoreIsCorrect, cantSchedulePosIsCorrect, cantFormsPerfectStoreIsCorrect, cantRelationPerfectStoreIsCorrect } = downloaded

        console.log('489 ---- downloaded:', JSON.stringify(downloaded, null, 2))
        setType(0)
        setCampaign(data)
        setStores(allStores)
        setMessageService('')

        const downloadInProgressStore = await StorageAdapter.getItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_STORES)
        const downloadInProgressSchedulePos = await StorageAdapter.getItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_SCHEDULE_POS)
        const downloadInProgressPerfectStore = await StorageAdapter.getItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_PERFECT_STORES)

        const isUserContentZipStore = await StorageAdapter.getItem(ASYNC_STORAGE_KEYS.IS_USER_CONTENT_ZIP)

        console.log('498 ------- 🚀 ~ setData ~ downloadInProgressPerfectStore:', downloadInProgressPerfectStore)

        const isDownloadScheduleInProgress = downloadInProgressSchedulePos ? downloadInProgressSchedulePos == 'true' : false
        const isDownloadStoreInProgress = downloadInProgressStore ? downloadInProgressStore == 'true' : false
        const isDownloadPerfectStoreInProgress = downloadInProgressPerfectStore ? downloadInProgressPerfectStore == 'true' : false
        const isUserContentZip = isUserContentZipStore ? isUserContentZipStore == 'true' : false
        console.log('507 -- 🚀 ~ setData ~ isUserContentZip:', isUserContentZip)

        console.log('🚀 ~ fetchData ~ setData - version:', version)

        let validateUpdateVersion = !errorService && version != null && cantStoreIsCorrect && cantSchedulePosIsCorrect

        if (isUserContentZip) {
            validateUpdateVersion =
                !errorService &&
                version != null &&
                cantStoreIsCorrect &&
                cantSchedulePosIsCorrect &&
                cantFormsPerfectStoreIsCorrect &&
                cantRelationPerfectStoreIsCorrect
        }

        console.log('🔍 [setData] Validación para actualizar versión:', {
            validateUpdateVersion,
            errorService,
            version,
            cantStoreIsCorrect,
            cantSchedulePosIsCorrect,
            cantFormsPerfectStoreIsCorrect,
            cantRelationPerfectStoreIsCorrect,
        })

        if (validateUpdateVersion) {
            console.log(`✅ [setData] Actualizando versión de agenda a: ${version}`)
            await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.SCHEDULES_VERSION, version)
        } else {
            let validateIfCantIsCorrect = !cantStoreIsCorrect || !cantSchedulePosIsCorrect

            if (isUserContentZip) {
                validateIfCantIsCorrect =
                    !cantStoreIsCorrect || !cantSchedulePosIsCorrect || !cantFormsPerfectStoreIsCorrect || !cantRelationPerfectStoreIsCorrect
            }

            if (validateIfCantIsCorrect) {
                // hasta no tener todas las descargas finalizadas no actualizo la version
                if (!isDownloadStoreInProgress && !isDownloadScheduleInProgress && !isDownloadPerfectStoreInProgress) {
                    console.log(
                        '⚠️ [setData] No se puede actualizar versión - Faltan datos:',
                        {
                            cantStoreIsCorrect,
                            cantSchedulePosIsCorrect,
                            cantFormsPerfectStoreIsCorrect,
                            cantRelationPerfectStoreIsCorrect,
                        }
                    )

                    // ❌ IMPORTANTE: No resetear a null si ya tenemos una versión
                    // Esto causaba descargas repetidas
                    const currentVersion = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.SCHEDULES_VERSION)
                    if (!currentVersion) {
                        console.log('🔄 [setData] Reseteando versión a null (no había versión previa)')
                        await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.SCHEDULES_VERSION, null)
                    } else {
                        console.log(`ℹ️ [setData] Manteniendo versión actual: ${currentVersion} (evitando re-descarga)`)
                    }
                } else {
                    console.log('⏳ [setData] Descarga en progreso, no cambiando versión')
                }
            } else {
                console.log('ℹ️ [setData] Todos los datos están correctos pero no se actualizó versión')
                console.log('🔍 [setData] errorService:', errorService)
                if (errorService && isConnected && hasInternet) {
                    await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.SCHEDULES_VERSION, null)
                    console.log(
                        '⚠️ [setData] Reseteando versión por errorService:',
                        {
                            cantStoreIsCorrect,
                            cantSchedulePosIsCorrect,
                        }
                    )
                }
            }
        }
    }

    const setMapButton = async () => {
        try {
            // ✅ Solo validar si los botones no están ya configurados
            const currentShowMapButton = useFooterButtonsStore.getState().showMapButton
            const currentShowCreatePosButton = useFooterButtonsStore.getState().showCreatePosButton

            // Si ambos botones ya están configurados, no hacer nada
            if (currentShowMapButton && currentShowCreatePosButton) {
                console.log('✅ Botones del footer ya configurados, omitiendo validación')
                return
            }

            // Si al menos uno no está configurado, consultar la API
            let res_get_footer_app = await UserServices.getSectionApp()
            console.log('🚀 ~ setMapButton ~ res_get_footer_app:', res_get_footer_app)
            if ((res_get_footer_app == null || res_get_footer_app.length == 0) && footer_app.length > 0) {
                res_get_footer_app = footer_app
            }

            if (res_get_footer_app && res_get_footer_app.length > 0) {
                const showMapButton = res_get_footer_app.find((item) => item.label == 'map')
                if (showMapButton && !currentShowMapButton) {
                    setShowMapButton(true)
                }

                // seteo create pos button
                const showCreatePosButton = res_get_footer_app.find((item) => item.label == 'createPos')
                // console.log('🟩🟩🟩🟩🟩🟩🟩🟩🟩🟩🟩 showCREATE =====>', showCreatePosButton)
                if (showCreatePosButton && !currentShowCreatePosButton) {
                    // ✅ Solo llamar a getAndSaveDataGeolocalization si no se ha configurado aún
                    await getAndSaveDataGeolocalization()
                    setShowCreatePosButton(true)
                }
            }
        } catch (error) {
            console.log('error => ', error)
        }
    }

    const getAndSaveGeoData = () => {
        try {
        } catch (error) {
            console.error('getAndSaveGeoData => ', getAndSaveGeoData)
        }
    }

    const saveScheduleAdvances = async (authToken, date_modified = null) => {
        //si falla adv no levanta status
        try {
            let page = 0
            let totalFetched = 0
            let size = 100
            let allSchedules = []
            //throw new Error('fallo el servicio de saveScheduleAdvances')
            while (true) {
                let get_user = await UserServices.getUser()

                if (!get_user || !get_user.login) break

                const get_data = await request_get_schedules_advances({
                    authToken: authToken,
                    page: page.toString(),
                    size: size.toString(),
                    date_modified: date_modified,
                    retries: 3,
                })

                const data = get_data.response

                // ✅ Validación segura: verificar que existan antes de acceder a .length
                if (!data || data.status !== 1 || !data?.single?.schedule_advances || !Array.isArray(data.single.schedule_advances) || data.single.schedule_advances.length === 0) {
                    console.log(`ℹ️ [saveScheduleAdvances] No hay más datos disponibles en página ${page}`)
                    break // Salir del bucle si no hay más datos
                }

                // Guardar los pos schedules advances en local
                let scheduleAdvance = data.single.schedule_advances
                let inserts = await insertInBatches(scheduleAdvance, scheduleAdvance.length)
                let filter_reg_recover_forms = scheduleAdvance.filter((item) => item.recover_forms == true)
                if (filter_reg_recover_forms.length > 0) {
                    await recoverFormsScheduleAdvance(filter_reg_recover_forms)
                }

                totalFetched += scheduleAdvance.length

                if (totalFetched >= data.single.total) {
                    break // Salir del bucle si se han obtenido todos los datos
                }

                page++
            }

            // console.log('Todos los pos schedules advances han sido guardados en la base de datos local.')
        } catch (error) {
            console.error('ERROR ADVANCE' + error)
        }
    }

    async function insertInBatches(data, chunkSize) {
        try {
            // Intentamos insertar el batch completo
            // await schedulesServices.addAdvancesSchedules(data)
            await addAdvancesSchedules(data)
        } catch (error) {
            // Verificamos si es un error de tamaño
            if ((error.message.includes('SQLITE_ERROR[1]') || error.message.includes('too many SQL variables')) && chunkSize > 1) {
                // Reducimos el tamaño del lote y tratamos de nuevo
                const middle = Math.ceil(data.length / 2)
                const firstHalf = data.slice(0, middle)
                const secondHalf = data.slice(middle)

                // Recursivamente llamamos a la función para cada mitad
                await insertInBatches(firstHalf, Math.floor(chunkSize / 2))
                await insertInBatches(secondHalf, Math.floor(chunkSize / 2))
            } else {
                // Si el chunkSize es 1 o no es un error de tamaño, lanzamos el error
                console.error('2 No se pudo insertar el batch:', error.message)
            }
        }
    }

    const saveForms = async (authToken) => {
        let response = { complete: false, forms: [] }
        try {
            const get_forms = await request_get_schedule_forms({ authToken })
            // console.log('🚀 ~ saveForms ~ get_forms:', get_forms)
            const responseForms = get_forms.response

            if (responseForms) {
                const total = responseForms.single.total
                await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_SCHEDULES_FORMS, total)

                setProgressSchedule(PROGRESS_STEPS.STEP_8.start)

                // Usar la nueva función optimizada del repositorio
                // Los parámetros wise, heladera, create_refrigerator, form_id_father se pasan como false/vacío por defecto
                // Batch size reducido a 50 para evitar locks de base de datos
                const savedCount = await saveFormsBatch(responseForms.single.forms, false, false, false, '', 500)

                setProgressSchedule(PROGRESS_STEPS.STEP_8.end)

                console.log(`✅ Todos los formularios guardados: ${savedCount}/${responseForms.single.forms.length}`)
                response = { complete: true, forms: responseForms.single.forms }
                return response
            }
        } catch (error) {
            console.error('Error al guardar los formularios:', error)
            return response
        }
    }

    const updateScheduleAdvances = async (authToken, date_modified = null) => {
        try {
            let page = 0
            let totalFetched = 0
            const size = 100
            let allSchedules = []
            const get_adv = await request_get_schedules_advances({
                authToken: authToken,
                page: page.toString(),
                size: size.toString(),
                date_modified: date_modified,
                retries: 0,
            })
            const data = get_adv.response
            if (data.status == 1 && data.single && data.single.schedule_advances.length > 0) {
                // setLoading(true)
                // const get_item_stop = await AsyncStorage.getItem(STOP_PROCESS)
                // if (get_item_stop != 'true') {
                //     console.log('4 INICIO START GENERAL LOADER: ', new Date()) // @
                //     eventEmitter.emit('starGeneralLoaderCustom') //* ABRO
                // }
                let recoverFormsArray = []
                // Guardar los schedules advances en local
                for (const schedule of data.single.schedule_advances) {
                    // console.log('Nuevos avances:', JSON.stringify(schedule))
                    await addOrUpdateAdvanceSchedule(schedule).catch((error) => console.error(error))
                    // Filtrar los avances con recover_forms: true
                    if (schedule.recover_forms) {
                        recoverFormsArray.push(schedule)
                    }
                }
                console.log('Todos los schedules advances han sido procesados.')
                // Llamar a recoverFormsScheduleAdvance si hay avances con recover_forms: true
                if (recoverFormsArray.length > 0) {
                    await recoverFormsScheduleAdvance(recoverFormsArray)
                }
            }
            setLoading(false)
            return
        } catch (error) {
            setLoading(false)
            console.error('Error en updateScheduleAdvances:', error)
        }
    }

    const recoverFormsScheduleAdvance = async (recoverFormsArray) => {
        try {
            console.log('Procesando recover forms:', recoverFormsArray.length)
            for (const adv of recoverFormsArray) {
                // Lógica para recuperar los formularios
                sendFormsRealizedStore(adv.schedule_id, adv.pos_id)
            }
            console.log('Todos los formularios de recoverFormsScheduleAdvance han sido procesados.')
        } catch (error) {
            console.error('🚀 ~ recoverFormsScheduleAdvance ~ error:', error)
        }
    }

    const findFormsRealizedInStore = async (scheduleID, storeID) => {
        try {
            // const { existsInDB, _id_mongoDB } = await schedulesServices.getExistsInDB(storeID)
            const { existsInDB, _id_mongoDB } = await getExistsInDB(storeID)

            const forms = await schedulesServices.getFormsRealizedByStore(scheduleID, storeID, _id_mongoDB)
            let filterFormsPending = forms.filter((form) => form.status_send == FORM_SCHEDULE_STATUS.PENDING_CONNECTION)

            if (existsInDB && filterFormsPending.length > 0) {
                filterFormsPending = filterFormsPending.map((form) => {
                    return {
                        ...form,
                        store_id: _id_mongoDB,
                    }
                })
            }

            return filterFormsPending
        } catch (error) {
            console.error('Error en findFormsRealizedInStore:', error)
            return []
        }
    }

    const sendFormsRealizedStore = async (scheduleId, storeId) => {
        try {
            const hasConnection = await validateConnectionNetwork()
            const resFormsPending = await findFormsRealizedInStore(scheduleId, storeId)
            if (hasConnection) {
                let status_send = 0
                for (const formPending of resFormsPending) {
                    const form_id = formPending.form_id
                    const store_id = formPending.store_id
                    const schedule_id = formPending.schedule_id
                    const register_id = formPending._id

                    let STATUS_FORM = FORM_SCHEDULE_STATUS.COMPLETED

                    const responseSendForm = await sendForm(STATUS_FORM, null, schedule_id, form_id, store_id, () => {}, register_id)

                    status_send =
                        typeof responseSendForm === 'object' && responseSendForm?.send_status
                            ? responseSendForm.send_status
                            : (responseSendForm as number)

                    if (status_send) {
                        console.log('==============>>🚚 envio el form', form_id)
                        await schedulesServices.updateStatusFormAnswerSchedule(
                            FORM_SCHEDULE_STATUS.COMPLETED,
                            schedule_id,
                            form_id,
                            store_id,
                            'PENDING_CONNECTION',
                            register_id,
                        )
                        //agrego la actualizacion de status en la nueva key status_send
                        await schedulesServices.updateStatusSendForm(
                            FORM_SCHEDULE_STATUS.COMPLETED,
                            schedule_id,
                            form_id,
                            store_id,
                            'error al enviar form PENDING_CONNECTION',
                            register_id,
                        )
                    }
                    console.log('status_send', status_send)
                }
            } else {
                // pasar la key checkout a false
                for (const formPending of resFormsPending) {
                    const register_id = formPending._id
                    const statusCheckout = false
                    await schedulesServices.updateKeyCheckoutFQA(statusCheckout, register_id)
                }
            }
        } catch (error) {
            console.error('sendFormsRealizedStore: ', error)
        }
    }

    const saveSchedulePos = async (authToken, type) => {
        try {
            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_SCHEDULE_POS, 'true')
            const pageSize = 100
            let page = 0
            let allSchedules = []
            //  throw new Error('fallo el servicio de saveSchedulePos')

            const get_initialResponse = await request_get_schedules_by_pos({
                authToken,
                type: type,
                page: page.toString(),
                size: pageSize.toString(),
            })

            const initialResponse = get_initialResponse.response

            let schedule_pos = []
            let url = null //'https://resources-one.s3.amazonaws.com/one_danone/temps/get_schedules_by_pos/647e28bb460e1100081a7b96_0_json_22016_04-11-2024-13-18.zip' //null
            if (
                initialResponse &&
                initialResponse.status === 1 &&
                initialResponse.single &&
                ((initialResponse.single.schedule_pos && initialResponse.single.schedule_pos.length > 0) ||
                    (initialResponse.single.location && initialResponse.single.location != ''))
            ) {
                if (initialResponse.single.location && initialResponse.single.location != '') {
                    url = initialResponse.single.location

                    const totalSchedulePos = getCountRegisterByUrl(url)
                    await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_SCHEDULES_POS, totalSchedulePos)
                    console.log('🚀 ~ saveSchedulePos request_get_schedules_by_pos - ~ url:', url)

                    schedule_pos = await downloadStores('schedule_stores', url)
                } else {
                    schedule_pos = initialResponse.single.schedule_pos
                    const totalSchedulePos = initialResponse.single.total
                    await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_SCHEDULES_POS, totalSchedulePos)
                }
                if (schedule_pos && schedule_pos.length > 0) {
                    allSchedules = [...allSchedules, ...schedule_pos]

                    await schedulesServices.deleteTableRegister(SCHEDULES_STORE_NAMES.SCHEDULES_POS)
                    
                    // ⏱️ Pequeño delay para asegurar que SQLite libere el lock completamente
                    await new Promise(resolve => setTimeout(resolve, 50))

                    let newScheduleStores = await insertInBatchesScheduleStores(schedule_pos)
                    console.log('🚀 ~ saveSchedulePos ~ newScheduleStores:', newScheduleStores)
                    await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_SCHEDULE_POS, 'false')
                    // await schedulesServices.addPosSchedules(schedule_pos)

                    page++ // Incrementar página para la próxima solicitud
                } else {
                    await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_SCHEDULE_POS, 'false')
                }
            } else {
                page++
                //throw new Error('No se encontraron datos válidos en la primera página de schedules_pos')
            }

            // Retornar los datos parciales después de la primera página
            const initialData = {
                status: 1,
                single: {
                    schedule_pos: allSchedules,
                },
                complete: true,
            }

            if (!url || url == '') {
                await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_SCHEDULE_POS, 'true')
                // Continuar obteniendo y guardando páginas siguientes en segundo plano
                ;(async () => {
                    while (true) {
                        let get_user = await UserServices.getUser()
                        if (!get_user || !get_user.login) break
                        // console.log('estoy en el bucle de tiendas', page, pageSize, get_user?.login)
                        // const session = await Auth.currentAuthenticatedUser({ bypassCache: true }).catch((err) => {
                        //     console.log('Error al obtener el usuario autenticado', err)
                        //     return null
                        // })
                        //  console.log('paginaaaaa saveSchedulePos  ', page)
                        const get_schedule_by_pos = await request_get_schedules_by_pos({
                            authToken: authToken,
                            type: type,
                            page: page.toString(),
                            size: pageSize.toString(),
                        })
                        const response = get_schedule_by_pos.response

                        // console.log('🚀 ~ ; ~ response:', response.status)
                        if (
                            !response ||
                            (response && response.status !== 1) ||
                            !response.single ||
                            !response.single.schedule_pos ||
                            response.single.schedule_pos.length === 0
                        ) {
                            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_SCHEDULE_POS, 'false')
                            break // Salir del bucle si no hay más datos
                        }

                        const { schedule_pos } = response.single
                        allSchedules = [...allSchedules, ...schedule_pos]

                        // Guardar los datos localmente después de procesar una página
                        let newScheduleStores = await insertInBatchesScheduleStores(schedule_pos)
                        //await schedulesServices.addPosSchedules(schedule_pos)

                        page++ // Incrementar página para la próxima solicitud
                    }
                    await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_SCHEDULE_POS, 'false')

                    //console.log(`Todas las páginas de schedules_pos han sido obtenidas y guardadas.`)
                })()
            }

            return initialData
        } catch (error) {
            console.error(error)
            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_SCHEDULE_POS, 'false')
        }
    }

    const saveAllStores = async (authToken, type, scheduleVersion = null) => {
        console.log(`📦 [saveAllStores] Iniciando guardado de tiendas (type: ${type})...`)
        try {
            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_STORES, 'true')
            loaderSaveStores.resetValues()
            const pageSize = 100
            let page = 0
            let allStores = []
            let url = null
            let stores = []
            
            // Obtener versión actual de tiendas
            const currentStoresVersion = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.STORES_VERSION)
            console.log('📦 [saveAllStores] Versión actual de tiendas:', currentStoresVersion)
            console.log('📦 [saveAllStores] Versión de schedule a guardar:', scheduleVersion)
            
            setDescriptionLoading(MESSAGE_STATES.OBTENIENDO_TIENDAS)
            const get_item_stop = await AsyncStorage.getItem(STOP_PROCESS)
            if (get_item_stop != 'true') {
                console.log('5 INICIO START GENERAL LOADER: ', new Date())
                eventEmitter.emit('starGeneralLoaderCustom', messageService, MESSAGE_STATES.OBTENIENDO_TIENDAS) //* ABRO
            }

            //throw new Error('fallo el servicio de saveAllStores')
            const get_initialResponse = await request_get_all_store({
                authToken,
                page: page.toString(),
                size: pageSize.toString(),
                type: type,
                version: currentStoresVersion,
            })

            console.log('🚀🚀🚀🚀 ~ saveAllStores ~ get_initialResponse:', {
                page: page.toString(),
                size: pageSize.toString(),
                type: type,
                response: get_initialResponse,
            })

            const initialResponse = get_initialResponse.response
            console.log('📦 [saveAllStores] Versión recibida del backend:', initialResponse?.single?.data_version)
            
            //let url = initialResponse.single.location //'https://resources-one.s3.us-east-2.amazonaws.com/one_danone/temps/get_all_store/647e28bb460e1100081a7b95_0_json_20197_01-11-2024-14-09.zip'
            // let url = 'https://resources-one.s3.us-east-2.amazonaws.com/one_danone/temps/get_all_store/639b5a2b2ff3f800095c44d2_0_json_20197_01-11-2024-17-43.zip'
            if (
                initialResponse &&
                initialResponse.status === 1 &&
                initialResponse.single &&
                ((initialResponse.single.stores && initialResponse.single.stores.length > 0) ||
                    (initialResponse.single.location && initialResponse.single.location != ''))
            ) {
                if (initialResponse.single.location && initialResponse.single.location != '') {
                    setValueStoreZip(true)
                    await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.HAS_STORES_ZIP, 'true')

                    url = initialResponse.single.location
                    const totalStores = getCountRegisterByUrl(url)
                    console.log('1301 - totalStores ===============> ', totalStores)
                    await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_STORES, totalStores)
                    setDescriptionLoading(MESSAGE_STATES.DESCOMPRIMIENDO)
                    const get_item_stop = await AsyncStorage.getItem(STOP_PROCESS)
                    if (get_item_stop != 'true') {
                        console.log('6 INICIO START GENERAL LOADER: ', new Date())
                        eventEmitter.emit('starGeneralLoaderCustom', messageService, MESSAGE_STATES.DESCOMPRIMIENDO) //* ABRO
                    }

                    setProgressSchedule(PROGRESS_STEPS.STEP_2.start)
                    let storesData = await downloadStores('stores', url)

                    if (storesData && storesData.length > 0) {
                        loaderSaveStores.set_total_stores(storesData.length)
                        allStores = [...allStores, ...storesData]

                        let newText = `${MESSAGE_STATES.DESCARGANDO} ${storesData.length} tiendas...`
                        setDescriptionLoading(newText)
                        let get_item_stop = await AsyncStorage.getItem(STOP_PROCESS)
                        if (get_item_stop != 'true') {
                            eventEmitter.emit('starGeneralLoaderCustom', messageService, newText, storesData.length) //* ABRO
                        }

                        console.log(`🗑️ [saveAllStores] Eliminando registros anteriores de tiendas...`)
                        await schedulesServices.deleteTableRegister(SCHEDULES_STORE_NAMES.STORES)
                        console.log(`✅ [saveAllStores] Registros anteriores eliminados`)
                        
                        // ⏱️ Pequeño delay para asegurar que SQLite libere el lock completamente
                        await new Promise(resolve => setTimeout(resolve, 50))

                        console.log(`📦 [saveAllStores] Insertando ${storesData.length} tiendas en batches...`)
                        let newStores = await insertInBatchesStores(storesData)
                        console.log(`✅ [saveAllStores] ${newStores || 0} tiendas insertadas`)

                        // Guardar nueva versión de tiendas SOLO después de inserción exitosa
                        if (scheduleVersion) {
                            await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.STORES_VERSION, scheduleVersion)
                            console.log('✅ [saveAllStores] Versión de tiendas actualizada a:', scheduleVersion)
                        }

                        setDescriptionLoading('')
                        get_item_stop = await AsyncStorage.getItem(STOP_PROCESS)
                        if (get_item_stop != 'true') {
                            console.log('8 INICIO START GENERAL LOADER: ', new Date())
                            eventEmitter.emit('starGeneralLoaderCustom', messageService, '') //* ABRO
                        }
                        await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_STORES, 'false')
                        // console.log('inserte primera pag')
                        page++ // Incrementar página para la próxima solicitud
                    } else {
                        await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_STORES, 'false')
                    }
                } else {
                    setValueStoreZip(false)
                    setDescriptionLoading('No se encuentran zips')
                    eventEmitter.emit('starGeneralLoaderCustom', messageService, 'No se encuentran zips')
                    stores = initialResponse.single.stores
                    let totalStores = initialResponse.single.total_stores
                    console.log('1305 - totalStores ===============> ', totalStores)
                    await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_STORES, totalStores)
                    
                    allStores = [...allStores, ...stores]
                    let newStores = await insertInBatchesStores(stores)
                    
                    // Guardar nueva versión de tiendas SOLO después de inserción exitosa
                    if (scheduleVersion) {
                        await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.STORES_VERSION, scheduleVersion)
                        console.log('✅ [saveAllStores] Versión de tiendas actualizada a:', scheduleVersion)
                    }
                    
                    await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_STORES, 'false')
                }

                // await schedulesServices.addPosSchedules(schedule_pos)

                page++ // Incrementar página para la próxima solicitud
            } else {
                await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_STORES, 'false')
                page++
                //throw new Error('No se encontraron datos válidos en la primera página de schedules_pos')
            }

            // Retornar los datos parciales después de la primera página
            const initialData = {
                status: 1,
                single: {
                    stores: allStores,
                },
                complete: true,
            }

            if (!url || url === '') {
                console.log('no tengo url..')
                await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_STORES, 'true')
                // Continuar obteniendo y guardando páginas siguientes en segundo plano
                ;(async () => {
                    while (true) {
                        let get_user = await UserServices.getUser()
                        if (!get_user || !get_user.login) {
                            console.log('no tengo usuario salgo del bucle de tiendas')
                            break
                        }

                        let response: GetAllStoresResponse
                        try {
                            const get_all_store = await request_get_all_store({
                                authToken,
                                page: page.toString(),
                                size: pageSize.toString(),
                                type: type,
                                version: currentStoresVersion,
                            })
                            response = get_all_store.response
                        } catch (error) {
                            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_STORES, 'false')
                            console.error('551 - Error al obtener las tiendas:', error)
                            break
                        }

                        if (
                            !response ||
                            (response && response.status !== 1) ||
                            !response.single ||
                            !response.single.stores ||
                            (response.single.stores.length == 0 && !response.single.location)
                        ) {
                            //console.log('840😇 no tengo mas datos, seteo en false')

                            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_STORES, 'false')

                            break // Salir del bucle si no hay más datos
                        }
                        let stores = response.single.stores

                        allStores = [...allStores, ...stores]
                        loaderSaveStores.set_stores_downloaded(allStores.length)
                        // Guardar los datos localmente después de procesar una página
                        try {
                            console.log(`📦 [saveAllStores] Insertando batch de ${stores.length} tiendas...`)
                            let newStores = await insertInBatchesStores(stores)
                        } catch (error) {
                            console.error('error en insertInBatchesStores:', error)
                        }

                        page++ // Incrementar página para la próxima solicitud
                    }

                    loaderSaveStores.set_isLoader(false)
                    console.log(`Todas las páginas de stores han sido obtenidas y guardadas.`)
                    //console.log('886 😇 sali del while, seteo en false')

                    await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_STORES, 'false')
                })()
            }

            return initialData
        } catch (error) {
            console.error('874 error en save_all_store', error)
            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_STORES, 'false')
        } finally {
            // console.log('===============Estoy en el finally de tiendas=====================')

            setDescriptionLoading('')
        }
    }

    const saveAllFormsPF = async (authToken) => {
        // console.log('🚀 ~ saveAllFormsPF ~ version:', version)
        const downloadInProgressPerfectStore = await StorageAdapter.getItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_PERFECT_STORES)
        console.log('498 ------- 🚀 ~ setData ~ downloadInProgressPerfectStore:', downloadInProgressPerfectStore)

        const isDownloadPerfectStoreInProgress = downloadInProgressPerfectStore ? downloadInProgressPerfectStore == 'true' : false
        console.log('1107 --- isDownloadPerfectStoreInProgress:', isDownloadPerfectStoreInProgress)
        if (!isDownloadPerfectStoreInProgress) {
            try {
                console.log('1030 --- 😇😇🚀 INICIO saveAllFormsPF')
                await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_PERFECT_STORES, 'true')
                await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.IS_USER_CONTENT_ZIP, 'false')
                let isCompleteFormsPS = false
                let isCompleteRelationPS = false

                const NAME_FOLDER = ''

                const currentVersionPS = await UserServices.getGlobalVersion(SCHEDULES_STORE_NAMES.PERFECT_STORE_VERSION)
                console.log('971 -- 🚀 ~ saveAllFormsPF ~ currentVersionPS:', currentVersionPS)
                const get_initialResponse = await request_get_perfect_store({ authToken, version: currentVersionPS })
                const initialResponse = get_initialResponse.response

                // console.log('978 -- 🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀 ~ saveAllFormsPF ~ initialResponse:', initialResponse)
                if (
                    initialResponse &&
                    initialResponse.status === 1 &&
                    initialResponse.single &&
                    initialResponse.single.location_zip &&
                    initialResponse.single.location_zip != ''
                ) {
                    await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.IS_USER_CONTENT_ZIP, 'true') // seteo que tiene zip
                    await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.IS_USER_CONTENT_ZIP_PS, 'true') // seteo que tiene zip

                    setShowDownloadAssetPS(true)
                    let get_item_stop = await AsyncStorage.getItem(STOP_PROCESS)
                    if (get_item_stop != 'true') {
                        console.log('9 INICIO START GENERAL LOADER: ', new Date())
                        eventEmitter.emit('starGeneralLoaderCustom', messageService, MESSAGE_STATES.OBTENIENDO_FORMULARIOS_PS) //* ABRO
                    }
                    let url = initialResponse.single.location_zip
                    const dataJsons: string[] = [initialResponse.single.location_backup_forms, initialResponse.single.location_backup_pos]
                    const countData = getDataCountByUrl(url)
                    const versionPath = getVersionByURL(url)
                    const idURL = getIdByURL(url)

                    try {
                        console.log(`📦 [saveAllFormsPF] Guardando ${initialResponse.single.location_backup_assets.length} links de assets...`)
                        const savedLinks = await saveAllLinksAssetsBatch(initialResponse.single.location_backup_assets, 500)
                        console.log(
                            `✅ [saveAllFormsPF] Links de assets guardados: ${savedLinks}/${initialResponse.single.location_backup_assets.length}`,
                        )
                    } catch (error) {
                        console.error('❌ [saveAllFormsPF] Error en saveAllLinksAssetsBatch:', {
                            error: error?.message || error,
                            name: error?.name,
                            assetsCount: initialResponse.single.location_backup_assets.length,
                            stack: error?.stack?.split('\n').slice(0, 3),
                        })
                        throw error // Re-lanzar para que se capture en el catch superior
                    }

                    let countFormsPerfectStore = countData ? countData.forms : 0
                    let countRelationPerfectStores = countData ? countData.pos : 0
                    let countAssetsPerfectStore = countData ? countData.assets : 0

                    const versionUpdate = `${idURL}_${versionPath}`

                    await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_FORMS_PERFECT_STORE, countFormsPerfectStore)
                    await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_RELATION_PERFECT_STORE, countRelationPerfectStores)
                    await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.COUNT_ASSETS_PERFECT_STORE, countAssetsPerfectStore)

                    const pathFather = `${documentDirectory}unzipped/`
                    const pathFatherJsons = 'jsons'
                    get_item_stop = await AsyncStorage.getItem(STOP_PROCESS)
                    if (get_item_stop != 'true') {
                        console.log('10 INICIO START GENERAL LOADER: ', new Date())
                        eventEmitter.emit('starGeneralLoaderCustom', messageService, MESSAGE_STATES.DESCARGANDO) //* ABRO
                    }
                    // console.log('2😇 loading desde saveAllFormsPF')
                    try {
                        //await downloadAndUnzipAllFiles(pathFatherJsons, url) // descargo el zip
                        await downloadZip(pathFatherJsons, url)
                    } catch (error) {
                        console.error('Error al descargar los jsons:', error)
                        throw new Error('Error al descargar los jsons:', error)
                    }

                    await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.PS_ASSETS_ALL_SAVED, 'false')
                    await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.PS_ZIP_ALL_SAVED, 'false')
                    //* aca tengo que terminar ps

                    const downloadAssestsPS = async () => {
                        await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_ASSETS_PERFECT_STORES, 'true')

                        let hasErrorInDownloadAssets = true
                        const isDownloadAssets = true
                        let formsInfo = null
                        try {
                            const size = 10
                            try {
                                if (initialResponse.single.location_backup_assets && initialResponse.single.location_backup_assets.length > 0) {
                                    setTextsInitial(languageFile.downloading_perfect_store)
                                    setShowAlertSnackbar(true)
                                    // await downloadContent(pathFatherJsons, dataJsons) // descargo los dos jsons
                                    const responseDownloadAssets = await downloadContentPS(
                                        pathFatherAssets,
                                        initialResponse.single.location_backup_assets,
                                        size,
                                        updatePSProgressSnackBar,
                                        isDownloadAssets,
                                        viewModalErrorPSAssets,
                                    )
                                    // console.log('1075 -- 🚀 ~ saveAllFormsPF ~ responseDownloadAssets:', responseDownloadAssets)

                                    hasErrorInDownloadAssets = responseDownloadAssets.errorDescargadosCount > 0
                                }
                                const formsInfoFunc = await unZipPSData()
                                formsInfo = formsInfoFunc
                                // console.log("1249 -- 🚀 ~ downloadAssestsPS ~ hasErrorInDownloadAssets:", hasErrorInDownloadAssets)
                            } catch (error) {
                                console.error('1258 -- Error al descargar los assets:', error)
                                throw new Error('Error al descargar los assets:', error)
                            }
                        } catch (error) {
                        } finally {
                            if (!hasErrorInDownloadAssets && formsInfo && formsInfo.files_saved > 0) {
                                await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.PS_ASSETS_ALL_SAVED, 'true')
                                setTextFinally(languageFile.perfect_store_download)
                                setShowAlertSnackbar(true)
                                setIsDownloadedCompletePS(true)
                            }

                            await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.PERFECT_STORE_VERSION, versionUpdate)
                            console.log('😡 1262 --- PASO A FALSE DOWNLOAD IS PROGRESS PERFECT STORE Y ASSETS')
                            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_PERFECT_STORES, 'false')
                            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_ASSETS_PERFECT_STORES, 'false')
                            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.UNZIP_IN_PROGRESS_PS, 'false')
                        }
                    }

                    downloadAssestsPS()
                } else {
                    // console.log('1156 ---')
                    // console.log('😡 1271 --- PASO A FALSE DOWNLOAD IS PROGRESS PERFECT STORE')
                    await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_PERFECT_STORES, 'false')
                }
                const initialData = {
                    status: 1,
                    isCompleteRelationPS,
                    isCompleteFormsPS,
                }
                return initialData
            } catch (error) {
                console.error('982 ---- error: ', error)
                // eventEmitter.emit('endGeneralLoaderCustom')
                await UserServices.updateGlobalVersion(SCHEDULES_STORE_NAMES.PERFECT_STORE_VERSION, null)
                console.log('😡 1284 --- PASO A FALSE DOWNLOAD IS PROGRESS PERFECT STORE')

                await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_PERFECT_STORES, 'false')
            } finally {
                // eventEmitter.emit('endGeneralLoaderCustom')
                // console.log('😡 1290 --- PASO A FALSE DOWNLOAD IS PROGRESS PERFECT STORE')
                // await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_PERFECT_STORES, 'false')
            }
        } else {
        }
    }

    const unZipPSData = async () => {
        let info = { files_saved: 0, shouldShowSnackComplete: false }
        try {
            const isUnZipping = await StorageAdapter.getItem(ASYNC_STORAGE_KEYS.UNZIP_IN_PROGRESS_PS)
            if (isUnZipping && isUnZipping == 'true') {
                // console.log('Ya hay una descompresión en progreso de Perfect Store. Saliendo de la función.')
                // saveUnzippedPS()

                return info
            }
            const pathFatherJsons = 'jsons'

            const dirInfo = `${documentDirectory}zip/${pathFatherJsons}/downloaded.zip`
            let unzippedRoute = await unZip(dirInfo, pathFatherJsons, () => {
                // console.log('Descomprimiendo Perfect Store...')
                StorageAdapter.setItem(ASYNC_STORAGE_KEYS.UNZIP_IN_PROGRESS_PS, 'true')
                setTextsInitial(languageFile.decompressing_perfect_store)
                setShowAlertSnackbar(true)
            })
            // if (!unzippedRoute)
            if (unzippedRoute) {
                // console.log('El archivo ya fue eliminado')
                StorageAdapter.setItem(ASYNC_STORAGE_KEYS.UNZIP_IN_PROGRESS_PS, 'false')
                await schedulesServices.deleteTableRegister(SCHEDULES_STORE_NAMES.FORMS_PERFECT_STORE)
                await schedulesServices.deleteTableRegister(SCHEDULES_STORE_NAMES.STORES_PF_RELATION)
                
                // ⏱️ Pequeño delay para asegurar que SQLite libere el lock completamente
                await new Promise(resolve => setTimeout(resolve, 50))
            }
            let formsSaved = await saveUnzippedPS()
            info.files_saved = formsSaved.files_saved
            if (info.files_saved > 0) {
                info.shouldShowSnackComplete = true
            }
            return info
        } catch (error) {
            console.log('error en unzipPSData:', error)
            return info
        }
    }

    const saveUnzippedPS = async () => {
        let info = { files_to_save: 0, files_saved: 0 }
        try {
            const isSaving = await StorageAdapter.getItem(ASYNC_STORAGE_KEYS.SAVE_PS_FORMS)
            if (isSaving && isSaving == 'true') {
                // console.log('Ya se están guardando los forms.')
                return info
            }
            const pathFather = `${documentDirectory}unzipped/`
            const pathFatherJsons = 'jsons'

            const formsDirectory = `${pathFather}${pathFatherJsons}/`
            let formsArray = await findAssetsInDirectory(formsDirectory)
            if (!formsArray || formsArray.length === 0) {
                // console.log('No se encontraron formularios perfect store para guardar ')
                await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.SAVE_PS_FORMS, 'false')
                return
            }
            // formsArray = formsArray.filter((file) => file.includes('forms'))

            if (formsArray && formsArray.length > 0) {
                info.files_to_save = formsArray.length
                setTextsInitial(languageFile.saving_perfect_store)
                setShowAlertSnackbar(true)
                await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.SAVE_PS_FORMS, 'true')
                for (let i = 0; i < formsArray.length; i++) {
                    const formJson = formsArray[i]
                    const directory = `${pathFather}${pathFatherJsons}/${formJson}`
                    const readForm = await readAndParseJSON(directory)

                    if (readForm && readForm.length > 0) {
                        switch (true) {
                            case formJson.toLowerCase().includes('forms'):
                                await insertInBatchesFormsPF(readForm).catch((error) => console.log(error))
                                info.files_saved += 1
                                break
                            case formJson.toLowerCase().includes('pos'):
                                await insertInBatchesStoresFormsPF(readForm).catch((error) => console.log(error))
                                info.files_saved += 1
                                break
                            default:
                                console.log('No es un json válido: ', formJson)
                                break
                        }
                        await deletePathFile(directory) // elimino el json de forms
                    }

                    const progressFloat = i / formsArray.length
                    const progress = Math.trunc(progressFloat * 100)
                    updatePSProgressSnackBar(progress)
                }
            }
            console.log('Finalizo el guardado de Json PS')
            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.PS_ZIP_ALL_SAVED, 'true')
            return info
        } catch (error) {
            console.error('Error en saveUnzippedPS:', error)
            return info
        } finally {
            StorageAdapter.setItem(ASYNC_STORAGE_KEYS.SAVE_PS_FORMS, 'false')
            return info
        }
    }

    const viewModalErrorPSAssets = (total: number, pendings: number) => {
        console.log('1311 --- ejecuto viewModalErrorPSAssets')
        setShowAlertSnackbar(false)
        setTextError(languageFile.connection_interrupted)
        const faltantes = total - pendings
        // const countText = `\nFaltan por descargar ${faltantes} imágenes.`
        //languageFile.remain_downloaded + `${faltantes}` + languageFile.assets

        const textPendingError = faltantes ? languageFile.remain_downloaded + `${faltantes}` + languageFile.assets : languageFile.remain_downloaded

        setCountPendingError(textPendingError) // TODO FIX

        setTimeout(() => {
            setShowAlertSnackbar(true)
        }, 2000)

        // agregar fn para limpiar
    }

    const downloadStores = async (name: string, url: string) => {
        try {
            let data = null
            // setProgressSchedule(PROGRESS_STEPS.STEP_1.end)

            let path = await downloadAndUnzip(name, url, setProgressSchedule)
            console.log('712 --- PATH - 🚀 ~ downloadStores ~ path:', path)
            if (!path) {
                console.log('error al descargar')
                return data
            }
            const pathDelete = `${documentDirectory}zip/${name}/`

            await deleteZipFolder(pathDelete)

            let stores = await readAndParseJSON(path)

            if (!stores) {
                console.log('error al recuperar las tiendas')
                return data
            }
            data = stores
            return data
        } catch (error) {
            console.error('1005🚀 ~ downloadStores ~ error:', error)
            throw new Error('Error al descargar: ', error)
        }
    }

    async function insertInBatchesStores(data): Promise<number> {
        console.log(`📦 [insertInBatchesStores] Iniciando guardado de ${data.length} tiendas...`, new Date())

        setProgressSchedule(PROGRESS_STEPS.STEP_4.start)

        const validStores = data.filter(store => {
            // Validar que tenga _id (campo obligatorio)
            if (!store._id) {
                console.warn('⚠️ [insertInBatchesStores] Store sin _id descartado:', { 
                    segment: store.segment, 
                    name: store.name,
                    keys: Object.keys(store).length 
                })
                return false
            }
            
            return true
        })
        
        // Si no hay stores válidos, retornar 0
        if (validStores.length === 0) {
            console.error('❌ [insertInBatchesStores] No hay stores válidos para guardar')
            setProgressSchedule(PROGRESS_STEPS.STEP_4.end)
            return 0
        }

        let savedStores = 0
        try {
            console.log(`📦 [insertInBatchesStores] Llamando a addStoresBatch con ${validStores.length} registros válidos...`)
            // Usar validStores en lugar de data
            savedStores = await addStoresBatch(validStores, 500, 'STEP_4', setProgressSchedule)
            console.log(`✅ [insertInBatchesStores] Stores guardados exitosamente: ${savedStores}/${validStores.length}`)
            
            // 🔍 VERIFICACIÓN: Contar stores en la BD
            const realDb = await getRealDatabase()
            const count = await realDb.getFirstAsync(`SELECT COUNT(*) as count FROM stores;`)
            console.log(`🔍 [insertInBatchesStores] VERIFICACIÓN - Total stores en BD: ${count?.count}`)
        } catch (error) {
            console.error('❌ [insertInBatchesStores] Error al guardar stores:', {
                error: error?.message || error,
                name: error?.name,
                count: validStores.length,
                stack: error?.stack?.split('\n').slice(0, 3),
            })
            throw error
        }

        setProgressSchedule(PROGRESS_STEPS.STEP_4.end)
        console.log('✅ [insertInBatchesStores] Proceso completado', new Date())

        return savedStores
        // console.log('Todos los stores han sido guardados en la base de datos local.: ', new Date())
    }

    async function insertInBatchesScheduleStores(data) {
        console.log(`📦 [insertInBatchesScheduleStores] Iniciando guardado de ${data.length} schedule_pos...`, new Date())
        setProgressSchedule(PROGRESS_STEPS.STEP_7.start)

        let savedPosSchedules = 0
        try {
            console.log(`📦 [insertInBatchesScheduleStores] Llamando a addPosSchedulesBatch...`)
            // Usar la nueva función optimizada del repositorio con batch automático
            savedPosSchedules = await addPosSchedulesBatch(data, 500, 'STEP_7', setProgressSchedule)
            console.log(`✅ [insertInBatchesScheduleStores] PosSchedules guardados: ${savedPosSchedules}/${data.length}`)
            
            // 🔍 VERIFICACIÓN: Contar schedules_pos en la BD
            const realDb = await getRealDatabase()
            const count = await realDb.getFirstAsync(`SELECT COUNT(*) as count FROM schedules_pos;`)
            console.log(`🔍 [insertInBatchesScheduleStores] VERIFICACIÓN - Total schedules_pos en BD: ${count?.count}`)
        } catch (error) {
            console.error('❌ [insertInBatchesScheduleStores] Error al guardar pos schedules:', {
                error: error?.message || error,
                name: error?.name,
                count: data.length,
                stack: error?.stack?.split('\n').slice(0, 3),
            })
            throw error
        }

        setProgressSchedule(PROGRESS_STEPS.STEP_7.end)
        console.log('✅ [insertInBatchesScheduleStores] Proceso completado', new Date())

        return savedPosSchedules
    }

    async function insertInBatchesFormsPF(data) {
        console.log(`📦 [insertInBatchesFormsPF] Iniciando guardado de ${data.length} formularios PF...`, new Date())

        // const session = await Auth.currentAuthenticatedUser({ bypassCache: true }).catch((err) => {
        //     console.log('Error al obtener el usuario autenticado', err)
        //     return null
        // })
        // if (!session) return []

        try {
            console.log(`📦 [insertInBatchesFormsPF] Llamando a addAllFormsPFBatch...`)
            // Usar la nueva función optimizada del repositorio con batch automático
            const savedForms = await addAllFormsPFBatch(data)
            console.log(`✅ [insertInBatchesFormsPF] Formularios Perfect Store guardados: ${savedForms}/${data.length}`)
        } catch (error) {
            console.error('❌ [insertInBatchesFormsPF] Error al guardar formularios Perfect Store:', {
                error: error?.message || error,
                name: error?.name,
                count: data.length,
                stack: error?.stack?.split('\n').slice(0, 3),
            })
            throw error
        }
        console.log('✅ [insertInBatchesFormsPF] Todos los PF guardados', new Date())
    }

    async function insertInBatchesStoresFormsPF(data) {
        console.log('Inicio el guardado de los StoresFormsPF en la base de datos local.: ', new Date())

        // const session = await Auth.currentAuthenticatedUser({ bypassCache: true }).catch((err) => {
        //     console.log('Error al obtener el usuario autenticado', err)
        //     return null
        // })
        // if (!session) return []

        try {
            const savedRelations = await addAllStoresPFRelationBatch(data)
            console.log(`✅ Relaciones Perfect Store guardadas: ${savedRelations}/${data.length}`)
        } catch (error) {
            console.error('Error al guardar relaciones Perfect Store:', error)
            throw error
        }
        console.log('Todos los StoresFormsPF han sido guardados en la base de datos local.: ', new Date())
    }

    const goToStore = (
        id: string,
        forms: string[],
        scheduleID: string,
        steps: CampaignStepsModel[],
        forms_relevant: ActivitysModel[],
        forms_advances?: FormsAdvances[],
        distance?: number,
        store_status?: number,
        incidence_answer?: string | null,
    ) => {
        //  console.log('Deberia ir a tiendas')
        // console.log('617 --- JSON.stringify(forms_advances): ', JSON.stringify(forms_advances))
        // console.log('618 --- store_status: ', store_status)

        // [{"_id":"67082f250cace12e8db22d1e","progress":"","status":2}]

        navigation.navigate('StoreDetail', {
            storeID: id,
            forms: forms,
            scheduleID: scheduleID,
            steps: steps,
            forms_relevant: forms_relevant,
            forms_advances: forms_advances,
            distance: distance ?? 0,
            store_status: store_status,
            incidence_answer: incidence_answer,
        })

        TrackingServices.addTracking(id, TRACKINGS_TYPES.NAVIGATE_STORE, 'StoreDetail')
    }

    const goToForm = (id: string) => {
        //    console.log('Deberia ir a un form')
        // navigation.navigate('StoreDetail', { id: id})
    }

    const checkIn = async (distributor_id: any, schedule_id: any, lat: any, lng: any, dataSteps: any[] = []) => {
        //distri
        // verificar si estoy entre la distancia que me llega en el store
        try {
            let fecha_hoy = new Date()
            let offset = fecha_hoy.getTimezoneOffset()
            // Convertir la fecha y hora actual de UTC a la zona horaria local del usuario
            fecha_hoy.setMinutes(fecha_hoy.getMinutes() - offset)
            //seteo en 00 la fecha de hoy
            fecha_hoy.setHours(0, 0, 0, 0)
            let status_send = 0
            if (distributor_id) {
                let dif_utc = -new Date().getTimezoneOffset() / 60
                let checkinID = null
                if (isConnected && hasInternet) {
                    const session = await fetchAuthSession()
                    const authToken = session.tokens?.accessToken?.toString() || ''
                    const data = {
                        authToken: authToken,
                        body: {
                            schedule_id: schedule_id,
                            distributor_id: distributor_id,
                            lat: lat ? lat.toString() : null,
                            lng: lng ? lng.toString() : null,
                            date_init: new Date().toISOString(),
                            dif_utc: dif_utc.toString(),
                            steps_distributor: dataSteps,
                        },
                    }

                    const res = await request_checkin(data)
                    if (res && res.status) {
                        status_send = res.status
                        checkinID = res?.response?.single?.checkin_status?._id ?? ''
                    }
                }

                const data_local = {
                    date: new Date().toISOString(),
                    store_id: '',
                    lat_checkin: lat ? lat.toString() : null,
                    lng_checkin: lng ? lng.toString() : null,
                    schedule_id: schedule_id,
                    date_init: new Date().toISOString(),
                    dif_utc: dif_utc.toString(),
                    status: status_send ? FORM_SCHEDULE_STATUS.COMPLETED : FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                    steps_distributor: dataSteps,
                }

                await schedulesServices.add_checkin(data_local, checkinID, distributor_id).then((checkin) => {
                    // console.log('checkincheckincheckincheckincheckin', checkin)
                })
                await schedulesServices.update_status_store(
                    distributor_id,
                    schedule_id,
                    CampaignStatus.STATUS_FORM_IN_PROGRESS,
                    new Date().toISOString(),
                    true,
                )
            }
        } catch (error) {
            console.error('665 ------ checkIn: ', error)
        }
    }

    const checkout = async (distributor_id, schedule_id, lat, lng, checkin_id, activities) => {
        //para distri
        try {
            let fecha_hoy = new Date()
            let offset = fecha_hoy.getTimezoneOffset()
            // Convertir la fecha y hora actual de UTC a la zona horaria local del usuario
            fecha_hoy.setMinutes(fecha_hoy.getMinutes() - offset)
            //seteo en 00 la fecha de hoy
            fecha_hoy.setHours(0, 0, 0, 0)

            if (distributor_id) {
                let dif_utc = -new Date().getTimezoneOffset() / 60
                let checkinID = null
                let advance = null
                let status_send = 0
                if (isConnected && hasInternet) {
                    const session = await fetchAuthSession()
                    const authToken = session.tokens?.accessToken?.toString() || ''
                    const data = {
                        authToken: authToken,
                        body: {
                            distributor_id: distributor_id,
                            lat: lat.toString(),
                            lng: lng.toString(),
                            date_finish: new Date().toISOString(),
                            dif_utc: dif_utc.toString(),
                            schedule_id: schedule_id,
                            id_check_in: checkin_id,
                            activities: activities,
                        },
                    }

                    const res = await request_checkout(data)
                    if (res && res.status) {
                        status_send = res.status
                        checkinID = res?.response?.single?.checkin_status?._id ?? ''
                    }
                }

                // @fixme revisar
                const data_local = {
                    date: new Date().toISOString(),
                    store_id: '',
                    lat_checkout: lat.toString(),
                    lng_checkout: lng.toString(),
                    schedule_id: schedule_id,
                    date_finish: new Date().toISOString(),
                    dif_utc: dif_utc.toString(),
                    checkin_id: checkinID,
                    checkin_id_local: checkinID.toString(),
                    status: status_send ? FORM_SCHEDULE_STATUS.COMPLETED : FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                }
                await schedulesServices.add_checkout(data_local, checkinID, distributor_id).then((checkout) => {
                    // //  console.log('checkoutcheckoutcheckoutcheckoutcheckoutcheckout', checkout)
                })

                await schedulesServices.update_status_store(
                    distributor_id,
                    schedule_id,
                    CampaignStatus.STATUS_FORM_APPROVED,
                    new Date().toISOString(),
                    true,
                )
            }
        } catch (error) {
            console.error('665 ------ checkIn: ', error)
        }
    }

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

    const sendPendingConnection = async () => {
        let hasConnection = false
        try {
            hasConnection = await validateConnectionNetwork()
            if (!hasConnection) {
                // Silently skip when offline - this is expected behavior
                return
            }
            
            // Verifica si ya está en proceso el envio de pendientes
            const isProcessing = await AsyncStorage.getItem(PROCESSING_PENDINGS)
            // console.log('sendPendingConnection ~ isProcessing:', isProcessing)

            if (isProcessing == 'true') {
                // console.log('cancelado, ya se estan enviando los pendientes')
                return
            } else {
                await AsyncStorage.setItem(PROCESSING_PENDINGS, 'true')
            }
            // console.log('=====================>> datos a enviar sin conexion, checkins, checkouts y forms')
            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString() || ''
            //envio tiendas creadas localmente
            let send_stores = await sendPendingStores(authToken)
            // console.log('🚀 ~ sendPendingConnection ~ send_stores:', send_stores)
            //envio checkins
            const results = await schedulesServices.get_checkins_pending(FORM_SCHEDULE_STATUS.PENDING_CONNECTION)
            // console.log('==============>>🚚 checkins a enviar pendientes------> ', results.length)
            if (results && results.length > 0) {
                for (let i = 0; i < results.length; i++) {
                    let item = results[i]
                    item.lat = item.lat_checkin
                    item.lng = item.lng_checkin
                    item.objectives = item.objectives && item.objectives != '' ? JSON.parse(item.objectives) : []
                    item.formsIdsFqa = item.formsIdsFqa && item.formsIdsFqa != '' ? JSON.parse(item.formsIdsFqa) : []
                    const checkin_id_old = item.checkin_id
                    //envio el checkin
                    //si el envio esta ok actualizo mi checkin en base con status:enviado
                    const data = {
                        authToken: authToken,
                        body: item,
                    }

                    const check = await request_checkin(data)
                    if (check && check.status) {
                        let checkinID = check?.response?.single?.checkin_status?._id ?? ''
                        let update_check = await schedulesServices.updateCheckinStatus(item._id, 3, checkinID)
                        await schedulesServices.updateKeyCheckinFqa(checkinID, item.formsIdsFqa) // updateo los regsitros fqa con el checkinID
                        console.log(item._id, 'update_check:', update_check)
                        await schedulesServices.update_checkout_key_checkinID(item._id, checkinID) // actualizo el checkout con el checkinID

                        await updateCheckinAndCanSendFormsPendingSync(checkin_id_old, checkinID)

                        let checkout = await schedulesServices.get_checkout_by_id(item._id)
                        if (checkout) {
                            //item.checkin_id = checkinID
                            //envio el checkout
                            //si el envio esta ok actualizo mi checkout en base con status:enviado
                            const data = {
                                authToken: authToken,
                                body: {
                                    store_id: checkout.store_id,
                                    id_check_in: checkinID,
                                    lat: checkout.lat_checkout,
                                    lng: checkout.lng_checkout,
                                    date_finish: checkout.date_finish,
                                    dif_utc: checkout.dif_utc,
                                    schedule_id: checkout.schedule_id,
                                    forms_view: checkout.forms_view,
                                },
                            }

                            const check = await request_checkout(data)
                            if (check && check.status == 1) {
                                await schedulesServices.updateCheckoutStatus(item._id, CampaignStatus.STATUS_FORM_APPROVED)
                                await schedulesServices.update_status_store(
                                    checkout.store_id,
                                    checkout.schedule_id,
                                    CampaignStatus.STATUS_FORM_APPROVED,
                                    new Date().toISOString(),
                                )
                                // updateStoreStatus(checkout.store_id, FORM_SCHEDULE_STATUS.COMPLETED)
                                updateStoreStatus(checkout.store_id, CampaignStatus.STATUS_FORM_APPROVED)
                                setStoreStatus(checkout.store_id, CampaignStatus.STATUS_FORM_APPROVED)
                                try {
                                    await getAndUpdateScheduleAdvance(authToken)
                                } catch (error) {
                                    console.error('try getAndUpdateScheduleAdvance => ', error)
                                }
                            }
                        }
                    }
                }
            }

            //envio checkouts
            const results_checkouts = await schedulesServices.get_checkouts_pending(FORM_SCHEDULE_STATUS.PENDING_CONNECTION)
            // console.log('==============>>🚚 checkouts a enviar...', results_checkouts.length)
            if (results_checkouts.length > 0) {
                for (let i = 0; i < results_checkouts.length; i++) {
                    const item = results_checkouts[i]
                    let checkin_id = item.checkin_id
                    let store_id = item.store_id
                    let schedule_id = item.schedule_id

                    // console.log('checkin_id => ', checkin_id)

                    checkin_id = await getCheckinId(checkin_id, store_id, schedule_id)

                    // console.log('checkin_id final => ', checkin_id)

                    if (!isValidMongoId(checkin_id)) {
                        console.log(
                            'No se puede enviar el checkout porque el checkin_id no es valido. checkoutID: ',
                            item._id,
                            ' - checkin_id: ',
                            checkin_id,
                            ' - store_id: ',
                            store_id,
                            ' - schedule_id: ',
                            schedule_id,
                        )
                        continue
                    }

                    const data = {
                        authToken: authToken,
                        body: {
                            store_id: item.store_id,
                            id_check_in: checkin_id,
                            lat: item.lat_checkout,
                            lng: item.lng_checkout,
                            date_finish: item.date_finish,
                            dif_utc: item.dif_utc,
                            schedule_id: item.schedule_id,
                            forms_view: item.forms_view,
                        },
                    }

                    const check = await request_checkout(data)
                    // console.log('66666~ request_checkin ~ check:', check)
                    if (check && check.status == 1 && check.response.status == 1) {
                        await schedulesServices.updateCheckoutStatus(item._id, STORE_STATUS.APPROVED)

                        await schedulesServices.update_status_store(store_id, schedule_id, STORE_STATUS.APPROVED, new Date().toISOString())

                        updateStoreStatus(store_id, STORE_STATUS.APPROVED)
                        setStoreStatus(store_id, STORE_STATUS.APPROVED)

                        //paso los forms relacionados a checkout 0
                        const resFormsPending = await findFormsRealizedInStore(item.schedule_id, item.store_id)
                        if (resFormsPending.length > 0) {
                            for (const formPending of resFormsPending) {
                                await schedulesServices.updateKeyCheckoutFQA(formPending._id, STORE_STATUS.PENDING)
                            }
                        }

                        try {
                            await getAndUpdateScheduleAdvance(authToken)
                        } catch (error) {
                            console.error('try getAndUpdateScheduleAdvance => ', error)
                        }
                    }
                }
            }
        } catch (error) {
            // ✅ Suppress expected network errors when offline, only log unexpected errors
            const errorMessage = error?.message || String(error)
            
            if (errorMessage.includes('NetworkError') || errorMessage.includes('network')) {
                // Only log network errors if we initially had connection (unexpected disconnect)
                if (hasConnection) {
                    console.log('⚠️ Connection lost during sync. Data will retry later.')
                }
                // Silently ignore if we knew we were offline from the start
            } else if (errorMessage.includes('401') || errorMessage.includes('Unauthorized')) {
                console.error('⚠️ Authentication failed. Please check your login status.')
            } else {
                // Log unexpected errors
                console.error('Error syncing pending data:', errorMessage)
            }
            
            await AsyncStorage.setItem(PROCESSING_PENDINGS, 'false')
        } finally {
            try {
                //await sendSurveyPending(authToken)
                const hasConnection = await validateConnectionNetwork(true)
                if (hasConnection) {
                    await sendFormsPending()
                    await sendPendingImages()
                    await sendPendingFormSync()
                }
                await AsyncStorage.setItem(PROCESSING_PENDINGS, 'false')
            } catch (error) {
                console.error('386 --Error  => sendFormsPending: ', error)
            }
        }
    }

    /**
     * @description Actualiza el checkin y el estado de can_send en los formularios pendientes de sincronización.
     */
    const updateCheckinAndCanSendFormsPendingSync = async (checkin_id_old, checkin_id_new) => {
        try {
            const formsPending = await schedulesServices.getFormsPendingSyncByCheckinId(checkin_id_old)
            console.log('formsPending update checkinID ============> :', formsPending)
            if (formsPending.length > 0) {
                const formIds = formsPending.map((form) => form._id)
                console.log('formIds => ', formIds)
                await schedulesServices.updateCheckinIdFormsPendingSyncById(formIds, checkin_id_new)
                await schedulesServices.updateCanSendFormsPendingSyncById(formIds, true)
            }
        } catch (error) {
            console.error('Error updating checkin and can_send en formularios pendientes de sincronización:', error)
        }
    }

    const getCheckinId = async (checkinIdToSend: any, storeID, scheduleID) => {
        if (isValidMongoId(checkinIdToSend)) {
            return checkinIdToSend
        }
        let dataCheckinID = checkinIdToSend
        const dataCheckin = await schedulesServices.get_checkin(storeID, scheduleID)

        if (dataCheckin) {
            const index = dataCheckin.length - 1
            dataCheckinID = dataCheckin[index].checkin_id
        }
        return dataCheckinID
    }

    const sendPendingStores = async (authToken: string) => {
        try {
            const stores_new = await schedulesServices.get_newstores_pending(FORM_SCHEDULE_STATUS.PENDING_CONNECTION)
            // console.log('==============>>🚚 TIENDAS a enviar pendientes------> ', stores_new.length)
            for (let i = 0; i < stores_new.length; i++) {
                const item = stores_new[i]
                const data = {
                    authToken: authToken,
                    body: item['storeDetails'],
                }

                const send_store = await request_add_pos(data)
                // console.log('🚀 ~ sendPendingStores ~ send_store:', send_store)
                if (send_store.status == 1 && send_store.single.pos) {
                    //actualizo registros con este nuevo id
                    //schedule_adv
                    //checkin
                    //checkout
                    //formularios
                    const newStoreId = send_store.single.pos._id
                    // console.log('Nuevo storeID creado en online => ', newStoreId)
                    // console.log('Old storeID local => ', item._id)
                    await schedulesServices.updateStoreRecords(item._id, newStoreId)

                    await cleanupLocalStores()
                }
            }

            //*stores pendieng nuevo
            const stores_pending = await schedulesServices.getStoresAndOrganizationsPendings()
            const stores_pending_with_local_org = await schedulesServices.getStoresAndOrganizationsPendingsWithLocalOrg()

            // console.log('🚀 ~ sendPendingStores ~ stores_pending_with_local_org:', stores_pending_with_local_org)

            // console.log('==============>>🚚 🚚🚚🚚🚚 TIENDAS (nuevo) a enviar pendientes------> ', stores_pending.length)

            if (stores_pending && stores_pending.length) {
                for (const data of stores_pending) {
                    // console.log('store => ', JSON.stringify(data))

                    let data_send = data.data_send
                    const data_match = data.data_match

                    if (data_send.createOrganization == true) {
                        data_send.organization_code = data_match.organization.code
                        data_send.organization_local_id = data_match.organization._id
                    }

                    const registerPendingId = data._id

                    const organizationId = data_match.organization._id
                    const posId = data_match.pos._id
                    const scheduePosId = data_match.schedule_pos._id

                    // console.log('registerPendingId => ', registerPendingId)
                    // console.log('organizationId => ', organizationId)
                    // console.log('posId => ', posId)
                    // console.log('scheduePosId => ', scheduePosId)

                    let { status, pos, schedule_pos, organization } = await sendStore(data_send)

                    // console.log('status => ', status)
                    if (status && status == 1) {
                        // buscar primero si tengo registros en el dataSend con id de organizacion local
                        const localOrgId = data_send.organization_local_id
                        await verifyUpdatePendingStores(stores_pending_with_local_org, localOrgId, organization._id)

                        // elimino los registros que cree pendientes
                        await schedulesServices.removeStoresAndOrganizationsPendingsById(registerPendingId)
                        await schedulesServices.removeStoresPendingsById(posId)
                        await schedulesServices.removeSchedulePosPendingsById(scheduePosId)
                        await schedulesServices.removeOrganizationPendingsById(organizationId)

                        // creo en db local los registros creados igual que en mongo db
                        const dataCreated: dataCreatedDbLocalI = {
                            organizationCreate: organization,
                            posCreate: pos,
                            schedulePosCreate: schedule_pos,
                        }
                        const responseData = await createStoreInDBLocal(status, dataCreated, data)
                        // console.log('responseData => ', responseData)
                    }
                }
            }
        } catch (error) {
            console.error('🚀 ~ sendPendingStores ~ error:', error)
        }
    }

    const sendPendingFormSync = async () => {
        let hasConnection = false
        try {
            // ✅ Validate connection before attempting sync
            hasConnection = await validateConnectionNetwork(true)
            if (!hasConnection) {
                // Silently skip when offline - this is expected behavior
                return
            }

            const formsPendingSync = await schedulesServices.getFormsPendingSync()
            // console.log('==============>>🚚 FORMS SYNC a enviar pendientes------> ', formsPendingSync.length)
            if (formsPendingSync && formsPendingSync.length > 0) {
                // console.log('tengo forms pendientes de sincronizar')

                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ''

                const getStatusMap = (status: number) => {
                    const map = {
                        [FORM_SCHEDULE_STATUS.IN_PROGRESS]: STATUS_FORM_PENDING_SYNC.IN_PROGRESS,
                        [FORM_SCHEDULE_STATUS.PENDING_CONNECTION]: STATUS_FORM_PENDING_SYNC.SENDED,
                    }

                    return map[status] || status
                }

                const mapResponse = formsPendingSync.map((item) => {
                    return {
                        activity_id: item.activity_id,
                        status: getStatusMap(item.status),
                        date: item.date,
                        count: item.count,
                        form_name: item.form_name,
                        status_send: item.status_send,
                        schedule_id: item.schedule_id,
                        store_id: item.store_id,
                        checkin_id: item.checkin_id,
                    }
                })

                // console.log('🚀 ~ sendPendingFormSync ~ mapResponse:', mapResponse)

                const response = await request_send_forms_view({ authToken, data: mapResponse })
                // console.log('🚀 ~ sendPendingFormSync ~ response:', response)

                if (response && response.status == 1 && response.response && response.response.status && response.response.status == 1) {
                    // actualizo el status del form en la base de datos local
                    for (const form of formsPendingSync) {
                        await schedulesServices.updateFormPendingSyncStatusSend(form.schedule_id, form.activity_id, STATUS_FORM_PENDING_SYNC.SENDED)

                        // ✅ Actualizar el estado del formulario a COMPLETED después de la sincronización exitosa
                        // Solo actualizar si el formulario está en PENDING_CONNECTION (5)
                        // Obtenemos el status actual del formulario antes de actualizarlo
                        const currentFormData = await schedulesServices.getFormsAnswersInStore(
                            form.store_id, 
                            form.schedule_id, 
                            form.activity_id
                        )
                        
                        if (currentFormData && currentFormData.status === FORM_SCHEDULE_STATUS.PENDING_CONNECTION) {
                            await schedulesServices.updateStatusFormAnswerSchedule(
                                FORM_SCHEDULE_STATUS.COMPLETED,
                                form.schedule_id,
                                form.activity_id,
                                form.store_id,
                                'sincronizado exitosamente',
                            )
                        }
                    }
                }
            }
        } catch (error) {
            // ✅ Suppress expected network errors when offline, only log unexpected errors
            const errorMessage = error?.message || String(error)
            
            if (errorMessage.includes('NetworkError') || errorMessage.includes('network')) {
                // Only log network errors if we initially had connection (unexpected disconnect)
                if (hasConnection) {
                    console.log('⚠️ Connection lost during form sync. Data will retry later.')
                }
                // Silently ignore if we knew we were offline from the start
            } else if (errorMessage.includes('401') || errorMessage.includes('Unauthorized')) {
                console.error('⚠️ Authentication failed during form sync. Please check your login status.')
            } else {
                // Log unexpected errors
                console.error('Error syncing forms:', errorMessage)
            }
        }
    }

    const verifyUpdatePendingStores = async (registersPendingUpdateId: any[], localIdOrg: string, onlineIdOrg: string) => {
        console.log('registersPendingUpdateId => ', registersPendingUpdateId)
        console.log('localIdOrg => ', localIdOrg)
        console.log('onlineIdOrg => ', onlineIdOrg)

        if (
            !registersPendingUpdateId ||
            registersPendingUpdateId == null ||
            registersPendingUpdateId == undefined ||
            registersPendingUpdateId.length == 0
        ) {
            console.log('no hay registros pendientes de update')
            return
        }

        if (!localIdOrg || localIdOrg == null || localIdOrg == undefined) {
            console.log('no tengo id de organizacion local')
            return
        }
        // ---
        const findRegisters = registersPendingUpdateId.filter((item) => item.data_send.organization._id == localIdOrg)
        console.log('findRegisters.length => ', findRegisters.length)
        if (findRegisters && findRegisters.length > 0) {
            for (const findRegister of findRegisters) {
                const newRegister = replaceOrganizationId(findRegister, localIdOrg, onlineIdOrg)
                if (newRegister != null) {
                    await schedulesServices.removeStoresAndOrganizationsPendingsById(findRegister._id)
                    const result = await schedulesServices.saveStoresAndOrganizationsPendings(newRegister.data_send, newRegister.data_match)
                    console.log('result => ', result)
                }
            }
        }
    }

    const sendPendingImages = async () => {
        try {
            const get_images = await schedulesServices.getPendingsImage()
            // console.log('==============>>🚚 IMAGENES a enviar pendientes------> ', get_images.length)
            for (let i = 0; i < get_images.length; i++) {
                const item = get_images[i]

                let send_img = await uploadImage(item.filename, item.pickerResult_uri)
                // console.log('🚀 ~ sendPendingStores ~ send_store:', send_img)
                if (send_img) {
                    await schedulesServices.deletePendingImage(item.filename)
                }
            }
        } catch (error) {
            console.error('🚀 ~ sendPendingImages ~ error:', error)
        }
    }

    const downloadAssestsPendingPS = async () => {
        try {
            let shouldShouCompleteSnackbar = false
            const hasConnection = await validateConnectionNetwork()

            const downloadInProgressAssetsPerfectStore = await StorageAdapter.getItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_ASSETS_PERFECT_STORES)
            const isDownloadInProgressAssetsPerfectStore = downloadInProgressAssetsPerfectStore
                ? downloadInProgressAssetsPerfectStore == 'true'
                : false

            if (!hasConnection || isDownloadInProgressAssetsPerfectStore) {
                console.log(
                    '🚀 ~ downloadAssestsPendingPS ~ no hay conexion o ya esta descargando hasConnection - isDownloadPerfectStoreInProgress - isDownloadInProgressAssetsPerfectStore: ',
                    hasConnection,
                    isDownloadInProgressAssetsPerfectStore,
                )
                return shouldShouCompleteSnackbar
            }

            const linksAssetsPendingDownloadRes = await schedulesServices.getLinksAssetsPSDonwloadFailed()

            if (!linksAssetsPendingDownloadRes || linksAssetsPendingDownloadRes.length == 0) {
                return true
            }

            const linksAssetsPendingDownload = linksAssetsPendingDownloadRes.map((link) => {
                return link.rute
            })

            if (!linksAssetsPendingDownload || linksAssetsPendingDownload.length == 0) {
                return shouldShouCompleteSnackbar
            }

            console.log('1868 ==============>>🚚 empiezo la descarga de assests de ps pendientes------> ', linksAssetsPendingDownload.length)

            const size = 10
            const isDownloadAssets = true
            let hasErrorInDownloadAssets = true

            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_ASSETS_PERFECT_STORES, 'true')

            try {
                setTextsInitial(languageFile.downloading_perfect_store)
                setShowAlertSnackbar(true)
                const responseDownloadAssets = await downloadContentPS(
                    pathFatherAssets,
                    linksAssetsPendingDownload,
                    size,
                    updatePSProgressSnackBar,
                    isDownloadAssets,
                    () => {}, // viewModalErrorPSAssets
                )

                hasErrorInDownloadAssets = responseDownloadAssets.errorDescargadosCount > 0

                if (!hasErrorInDownloadAssets && responseDownloadAssets.total == responseDownloadAssets.descargados) {
                    console.log('✅✅✅-------- La descarga de assets de PS finalizo ---------✅✅')
                    shouldShouCompleteSnackbar = true
                    await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.PS_ASSETS_ALL_SAVED, 'true')
                    return shouldShouCompleteSnackbar
                    // setShowAlertSnackbar(true)
                    // setIsDownloadedCompletePS(true)
                }
            } catch (error) {
                console.error('1900 -- Error al descargar los assets:', error)
                await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_ASSETS_PERFECT_STORES, 'false')
                return shouldShouCompleteSnackbar
            }

            console.log('1907-- PASO A FALSE DOWNLOAD IS PROGRESS PERFECT STORE Y ASSETS')
            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_ASSETS_PERFECT_STORES, 'false')
        } catch (error) {
            console.error('1904 PASO A FALSE DOWNLOAD IS PROGRESS PERFECT STORE Y ASSETS: ', error)
            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.DOWNLOAD_IN_PROGRESS_ASSETS_PERFECT_STORES, 'false')
            return false
        } finally {
            // console.log('finalizo downloadAssestsPendingPS')
        }
    }

    const replaceOrganizationId = (store, idToReplace: string, newId: string) => {
        if (
            store.data_send &&
            store.data_send.createOrganization === false &&
            store.data_send.organization &&
            store.data_send.organization._id === idToReplace
        ) {
            const newStore = JSON.parse(JSON.stringify(store))

            newStore.data_send.organization._id = newId

            if (newStore.data_match && newStore.data_match.organization && newStore.data_match.organization._id === idToReplace) {
                newStore.data_match.organization._id = newId
            }

            if (newStore.data_match && newStore.data_match.pos && newStore.data_match.pos.organization_id === idToReplace) {
                newStore.data_match.pos.organization_id = newId
            }

            return newStore
        }
        return null
    }

    const updatePSProgressSnackBar = (text) => {
        let value = text + '%'
        setTextSecondary(value)
    }

    const downloadPendingPS = async () => {
        try {
            const shouldShowCompleteSnackbarAssets = await downloadAssestsPendingPS()
            const info = await unZipPSData()
            console.log('🚀 ~ downloadPendingPS ~ shouldShowCompleteSnackbarAssets:', shouldShowCompleteSnackbarAssets)
            console.log('🚀 ~ downloadPendingPS ~ info:', info)
            if (shouldShowCompleteSnackbarAssets && info.shouldShowSnackComplete) {
                setTextFinally(languageFile.perfect_store_download)
                setIsDownloadedCompletePS(true)
                setShowAlertSnackbar(true)
            }
            const ZipDownloaded = await StorageAdapter.getItem(ASYNC_STORAGE_KEYS.PS_ZIP_ALL_SAVED)
            const AssetsDownloaded = await StorageAdapter.getItem(ASYNC_STORAGE_KEYS.PS_ASSETS_ALL_SAVED)
            console.log('ZipDownloaded, AssetsDownloaded', ZipDownloaded, AssetsDownloaded)

            if (ZipDownloaded == 'true' && AssetsDownloaded == 'true') {
                setTextFinally(languageFile.perfect_store_download)
                setIsDownloadedCompletePS(true)
            }
        } catch (error) {
            console.log('Error: ', error)
        } finally {
        }
    }
    const setValueStoreZip = async (value: boolean) => {
        await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.HAS_STORES_ZIP, value.toString())
        setHasStoresZip(value)
    }
    const clearData = async () => {
        try {
            setCampaign([])
            setStores([])
            setAllStores([])
            setSchedule([])
            setHistoryForms([])
            setMessageService('')
            setErrorService(false)
            setShowMapButton(false)
            setShowCreatePosButton(false)
            setPercentage(0)
            //Reset snackbar
            setShowAlertSnackbar(false)
            setTextSecondary('')
            setIsDownloadedCompletePS(false)
            await StorageAdapter.setItem(ASYNC_STORAGE_KEYS.IS_USER_CONTENT_ZIP_PS, 'false')
            setShowDownloadAssetPS(false)
            setValueStoreZip(false)
        } catch (e) {
            console.log('clearData schedule error', e)
        }
    }

    return {
        campaign,
        goToForm,
        goToStore,
        loading,
        setLoading,
        loadingSchedule,
        reloadCounter,
        generator,
        checkIn,
        checkout,
        fetchData,
        messageService,
        historyForms,
        refreshForm,
        fetchDataGetHistoryForms,
        reloadCounterFn,
        showMapButton,
        showCreatePosButton,
        descriptionLoading,
        sendPendingConnection,
        downloadAssestsPendingPS,
        clearData,
        // updateTableTotals,
        unZipPSData,
        downloadPendingPS,
    }
}
